import { useState, useRef, useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import VehicleRequestDetail from "./VehicleRequestDetail";
import navOperations from "../../../../../redux/Navigation/operations";
import { selectors as purchaseOrderSelectors } from "../../../../../redux/PurchaseOrder";
import PurchaseDetail from "../PurchaseDetail";
import VendorDetail from "../VendorDetails";
import PurchaseOrderDetail from "../PurchaseOrderDetail";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import successBee from '../../../../assets/images/SuccessBee.svg'
import CommentBee from "../../../../assets/images/PenndingApproval/Comment Bee.png";
import purchaseOrderOperation from "../../../../../redux/PurchaseOrder/operations";
import { selectors as userProfileSelectors } from "redux/UserProfile";
import { CONSTANTS } from "client/utils/constants";
import AdminTask from "../AdminTask";
import { useNavigate, useParams } from 'react-router-dom'
import AssetNumberValue from 'Store/AssetManagement/AssetNumber/AssetNumberDispatch';
import { setFleetAssetValidation, setFleetItemId } from "Store/AssetManagement/AssetNumber/AssetNumberAction";
import { getFleetItemPurchaseDetails, getFleetItemPurchaseDetailsSave, getFleetItemPurchaseOrder, getFleetItemPurchaseOrderSave, getFleetItemTaskDetails, getFleetItemVendorDetails, getFleetItemVendorDetailsSave, saveComment, saveItemAttachmentsLinked, setLinkedAttachments, setReasonCodeResponse, saveItemDetails as saveNSEItemDetails, getFleetItemDetails, setFleetItemHeaderDetail, setVinValidationResult, validateVinDuplicate, getFleetItemHeaderDetail, setFleetItemPurchaseDetailsSave} from "Store/Component/FleetManagement/FleetManagementAction";
import { setError } from "redux/PurchaseOrder/action";
import { commonStepperFourOnClick, commonStepperOneOnClick, commonStepperThreeOnClick, commonStepperTwoOnclick, commononUploadClick, formatPrice, formatVinSerial, getYearDropdownList, isEmail, isValidPhone, popupInitialData, sanitizeE1Input } from "utils";
import { getOnlyNumbers } from "client/utils/RequisitionUtil";
import moment from "moment";
import Validation from "../../Requisition/RequisitionType/NonStandardEquipment/NonStandardEquipmentValidation"
import { Col, DropdownBox, Label, Row } from "client/CommonComponents";
import { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";
import { getSaveAdminTaskvalue } from "Store/FleetManagement/FleetAdminTask/AdminTaskAction";
import { removeBulkOrderAttachment, uploadBulkOrderAttachments } from "Store/Component/BulkOrder/BulkOrderAction";
import { setOrderDetail } from "redux/PendingOrder/action";
import { setOrderById } from "Store/OrderManagement/Order/OrderAction";
import { getAssetItemStatusVendorDetail } from "Store/FleetManagement/AssetItemStatusVendorDetail/AssetItemStatusVendorDetailAction";
import { getAssetItemStatusPurchaseOrder } from "Store/FleetManagement/AssetItemStatusPurchaseOrder/AssetItemStatusPurchaseOrderAction";
import { getAssetItemStatusPurchaseDetails } from "Store/FleetManagement/AssetItemStatusPurchaseDetail/AssetItemStatusPurchaseDetailAction";
import { getAssetItemStatusTaskDetail } from "Store/FleetManagement/AssetItemStatusTaskDetails/AssetItemStatusTaskDetailsAction";
import { getPoVendorEmail, getSendPoVendorEmail, setPoVendorEmail, uploadEmailAttachments } from "Store/AlertNotification/PoVendorEmail/PoVendorEmailAction";
import { getPoPdfLinkByPONumber, getRefreshPurchaseOrder, setIsPurchaseOrderRefreshed, setPoPdfLinkByPONumber } from "Store/FleetManagement/FleetrefreshPurchaseOrder/FleetRefreshPurchaseOrderAction";
import { getFleetVendorEmailHistory, setFleetVendorEmailHistory } from "Store/FleetManagement/FleetPOVendorEmailHistory/FleetPOVendorEmailHistoryAction";
import { getFleetPurchaseOrderHistory, setFleetPurchaseOrderHistory } from "Store/FleetManagement/FleetPurchaseOrderHistory/FleetPurchaseOrderHistoryAction";
import { getFleetItemReturnToRequestor, setFleetItemReturnToRequestor } from "Store/FleetManagement/FleetItemReturnToRequestor/FleetItemReturnToRequestorAction";
import { operations } from "redux/Navigation";

const VehicleRequestDetailContainer = ({
  itemDetails,
  accordionIndex,
  isShowComplete,
  setCancelledItemFleetId,
  isBulkOrder,
  cancelledItemFleetId,
  setCancelComment,
  cancelComment,
  onCatalogOverrideSaved
}: any) => {
  const [activeStepper, setActiveStepper] = useState<number>(1);
  const [skipVendorDetail, setSkipVendorDetail] = useState<boolean>(false);
  const [attachmentChangeFleetId, setAttachmentChangeFleetId] = useState<any>()
  const [uploadedList, setUploadedList] = useState<any>([]);
  const [list, setList] = useState<any>([])
  const [attachmentError, setAttachmentError] = useState<any>([])
  const [isnonStandardequipment, setisnonStandardequipment] = useState(false);
  const [ismanagedequipment, setismanagedequipment] = useState(false);
  const [isvehiclerequestequipment, setisvehiclerequestequipment] = useState(false);
  const [isVendorDetailsSkippedOnSave, setIsVendorDetailSkippedOnSave] = useState(false);
  const [isRefreshError, setIsRefreshError] = useState(false);
  const originalVinSerialRef = useRef<string>('');
  const lastDispatchedPayload = useRef<any>(null);

///Send email to Vendor attachments
const initialError = {
  toEmailError: '',
  bccEmailError: '',
  bodyEmailError:''
}
const [sendEmailAttachmentsList, setSendEmailAttachmentsList] = useState<any>([]);
const [sendEmailList, setSendEmailList] = useState<any>([])
const [emailAttachmentError, setEmailAttachmentError] = useState<any>([])
const [sendEmailError, setSendEmailerror] = useState<any>(initialError)

  useEffect(() => {
    if (itemDetails.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT) {
      setisnonStandardequipment(true);
    }
    else if (itemDetails.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT) {
      setismanagedequipment(true)
    }
    else {
      setisvehiclerequestequipment(true)
    }
  }, []);
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comment: "",
  });
  const [returnPopupcontent, setReturnPopupcontent] = useState<any>(popupInitialData)
  const StepperRef = useRef<any>(null);

  const dispatch = useDispatch();
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch)
  const [errors, setErrors] = useState<any>();
  const [assignedToError, setAssignedToError] = useState<any>();
  const [isAttachmentBtnClicked, setIsAttachmentBtnClicked] = useState<any>([]);
  const [enableEditNSE, setEnableEditNSE] = useState(false)
  const [editAssetInfo, setEditAssetInfo] = useState<any>({})
  const [showEmailPopup, setShowEmailPopup] = useState(false)
  const [isEmailSentAlert, setIsEmailSentAlert] = useState<any>({})
  const [returnSuccessPopupContent, setReturnsuccessPopupContent] = useState<any>(popupInitialData)

  let navigate = useNavigate();
  const navDispatch = operations.dispatchNav(dispatch);
    let { pagename } = useParams();
  const dispatchGetFleetAssetValidation = AssetNumberValue.dispatchGetFleetAssetValidation(dispatch);
  const dispatchStepperData =
    purchaseOrderOperation.dispatchSetPurchaseorderStepperData(dispatch);
  const dispatchSetError = purchaseOrderOperation.dispatchSetError(dispatch);
  const dispatchChangeLogs =
    purchaseOrderOperation.dispatchChangeLogs(dispatch);
  const dispatchStepperDataArr =
    purchaseOrderOperation.dispatchSetPurchaseorderStepperInfo(dispatch);
  const dispatchUpdateReasonCode = purchaseOrderOperation.dispatchUpdateReasonCode(dispatch)  

  const {
    orderDetails,
    assignTo,
    purchaseOrderStepperDataArr,
    error,
    userDetails,
    assetValidation,
    itemId,
    attachmentsList,
    linkedAttachment,
    isVehicleConsolidatedChecked,
    isManageEquipConsolidatedChecked,
    isNonstandardConsolidatedChecked,
    isSavePurchaseOrderLoading,
    savedStatus,
    SavedAdminTaskValue,
    reasonCode,
    reasonCodeUpdateResponse,
    itemAttachmentList,
    fleetItemDetails,
    fleetItemVendorDetailsSave,
    fleetItemPurchaseOrderSave,
    fleetItemPurchaseDetailsSave,
    isItemSaved,
    fleetItemPurchaseDetails,
    fleetItemPurchaseOrder,
    fleetItemVendorDetails,
    fleetItemTaskDetails,
    fleetItemCancel,
    poVendorEmailDetails,
    isPoVendorEmailSent,
    isPurchaseOrderRefreshed,
    fleetPOVendorEmailHistory,
    fleetPurchaseOrderHistory,
    poPdfLinkByPONumber,
    fleetItemReturn,
    fleetItemHeaderDetails,
    vinValidationResult,
  }: any = useSelector((state: any) => ({
    orderDetails: purchaseOrderSelectors.getOrderDetail(state),
    error: purchaseOrderSelectors.getError(state),
    assignTo: purchaseOrderSelectors.getAssignToDropdown(state),
    purchaseOrderStepperDataArr:
      purchaseOrderSelectors.getPurchaseOrderStepperData(state),
    userDetails: userProfileSelectors.getUserDetails(state),
    assetValidation: state.AssetNumber.assetValidation,
    itemId: state.AssetNumber.itemId,
    attachmentsList: state.fleetAdminTaskReducer.attachmentList,
    linkedAttachment: state.fleetAdminTaskReducer.linkedAttachments,
    isVehicleConsolidatedChecked: state.FleetProcessingReducer.isVehicleConsolidatedChecked,
    isManageEquipConsolidatedChecked: state.FleetProcessingReducer.isManageEquipConsolidatedChecked,
    isNonstandardConsolidatedChecked: state.FleetProcessingReducer.isNonstandardConsolidatedChecked,
    isSavePurchaseOrderLoading: state.FleetProcessingReducer.isSavePurchaseOrderLoading,
    savedStatus: state.adminTaskReducer.savedStatus,
    SavedAdminTaskValue: state.adminTaskReducer.SavedAdminTaskValue,
    reasonCode: state.ReasonCodeReducer.requisitionReasonCodeList,
    reasonCodeUpdateResponse: state.fleetAdminTaskReducer.updateReasonCodeResponse,
    itemAttachmentList: state.BulkOrderReducer.attachmentList,
    fleetItemDetails: state.fleetAdminTaskReducer?.fleetItemDetails,
    fleetItemVendorDetailsSave: state.fleetAdminTaskReducer?.fleetItemVendorDetailsSave,
    fleetItemPurchaseOrderSave: state.fleetAdminTaskReducer?.fleetItemPurchaseOrderSave,
    fleetItemPurchaseDetailsSave: state.fleetAdminTaskReducer?.fleetItemPurchaseDetailsSave,
    isItemSaved: state.fleetAdminTaskReducer?.isItemSaved,
    fleetItemPurchaseDetails: state.fleetAdminTaskReducer?.fleetItemPurchaseDetails,
    fleetItemPurchaseOrder: state.fleetAdminTaskReducer?.fleetItemPurchaseOrder,
    fleetItemVendorDetails: state.fleetAdminTaskReducer?.fleetItemVendorDetails,
    fleetItemTaskDetails: state.fleetAdminTaskReducer?.fleetItemTaskDetails,
    fleetItemCancel: state.FleetItemCancelReducer.FleetItemCancel,
    poVendorEmailDetails: state.PoVendorEmailReducers.poVendorEmailDetails,
    isPoVendorEmailSent: state.PoVendorEmailReducers.isPoVendorEmailSent,
    isPurchaseOrderRefreshed: state.FleetRefreshPurchaseOrderReducer.isPurchaseOrderRefreshed,
    fleetPOVendorEmailHistory: state.POVendorEmailHistoryReducers.fleetVendorEmailHistory,
    fleetPurchaseOrderHistory: state.FleetPurchaseOrderHistoryReducers.fleetPurchaseOrderHistory,
    poPdfLinkByPONumber: state.FleetRefreshPurchaseOrderReducer.poPdfLinkByPONumber,
    fleetItemReturn : state.FleetItemReturnReducer.fleetItemReturn,
    fleetItemHeaderDetails: state.fleetAdminTaskReducer?.fleetItemHeaderDetails,
    vinValidationResult: state.fleetAdminTaskReducer?.vinValidationResult,
  }));

  const purchaseOrderStepperData = useMemo(() => {
    const data = purchaseOrderStepperDataArr?.length
      ? purchaseOrderStepperDataArr?.find(
        (item: any) =>
          +item?.itemNumber === +String(itemDetails?.itemId).split("-")[1]
      ) || {}
      : {};
    
    // Sanitize E1 fields when data is populated
    if (data?.poDescription1) {
      data.poDescription1 = sanitizeE1Input(data.poDescription1);
    }
    if (data?.poDescription2) {
      data.poDescription2 = sanitizeE1Input(data.poDescription2);
    }
    
    return data;
  }, [purchaseOrderStepperDataArr]);

  // Check if user is SuperAdmin
 const getUserRoles = () => {
    let roles = userDetails?.roles?.map((role: any) => role.roleName)
    return roles
  }

  useEffect(() => {
    setError({ assetNumber: false })
    setList([])
    setAttachmentError('')
    originalVinSerialRef.current = ''
  }, []);

  useEffect(() => {
    if (isPurchaseOrderRefreshed?.hasOwnProperty('isRefreshed') && isPurchaseOrderRefreshed?.isRefreshed && isPurchaseOrderRefreshed != null && purchaseOrderStepperData?.fleetRequestDetailId == isPurchaseOrderRefreshed?.fleetRequestDetailId) {
      if (fleetPurchaseOrderHistory != null && fleetPurchaseOrderHistory?.length) {
        let tempData = fleetPurchaseOrderHistory?.find(
          (item: any) => item?.id == itemDetails?.fleetRequestDetailId
        );
        if (tempData?.isOpen) {
          dispatch(
            getFleetPurchaseOrderHistory({
              fleetDetailId: itemDetails?.fleetRequestDetailId,
              poNumber: itemDetails?.poNumber,
              pageNumber: tempData?.pageNumber,
              pageSize: tempData?.pageSize,
            })
          )
        }
      }
      let poDetailsArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr))
      poDetailsArr?.forEach((item: any, index: any) => {
        if (item?.poNumber == isPurchaseOrderRefreshed?.poNumber) {
          item.poPdfUrl = isPurchaseOrderRefreshed?.response
        }
      })
      dispatchStepperDataArr(poDetailsArr)
      dispatch(setIsPurchaseOrderRefreshed(null))
    } else if (isPurchaseOrderRefreshed != null && !isPurchaseOrderRefreshed?.isRefreshed && purchaseOrderStepperData?.fleetRequestDetailId == isPurchaseOrderRefreshed?.fleetRequestDetailId) {
      dispatch(setIsPurchaseOrderRefreshed(null))
      setIsRefreshError(true)
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: "Error occured while refreshing the Purchase order.",
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
      });
    }
  }, [isPurchaseOrderRefreshed])

  useEffect(() => {
    if (itemDetails?.fleetRequestDetailId === itemAttachmentList?.requestIndex) {
      const tempPoData = orderDetails?.poDetails?.map((item: any)=>{
      if (item?.fleetRequestDetailId === itemAttachmentList?.requestIndex) {
        setUploadedList(itemAttachmentList?.list ?? []);
        setList(itemAttachmentList?.list ?? [])
        return {
          ...item,
          poAttachments : itemAttachmentList?.list ?? []
        }
      } else {
        return item
      }
    })
    dispatch(setOrderDetail({...orderDetails, poDetails: tempPoData}))
    if (activeStepper == 4 || (activeStepper == 2 && skipVendorDetail)) {
      setAttachmentChangeFleetId(purchaseOrderStepperData?.fleetRequestDetailId)
    }
  }
  }, [itemAttachmentList?.list])

  const updatePODetailsArray = (fleetItemDetails: any) => {
    if(purchaseOrderStepperData?.fleetRequestDetailId === fleetItemDetails?.fleetId){
      dispatchStepperData({...purchaseOrderStepperData, ...fleetItemDetails, pricePerUnit: fleetItemDetails?.pricePerUnit ? formatPrice(fleetItemDetails?.pricePerUnit,2) : purchaseOrderStepperData?.pricePerUnit, isCipPoolSaved : purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cipUnitNumber')})
    }
}

const updatePOItemDetails = (fleetItemDetails: any) => {
  if(purchaseOrderStepperData?.fleetRequestDetailId === fleetItemDetails?.fleetId){
    dispatchStepperData({...purchaseOrderStepperData, ...fleetItemDetails, attachments: fleetItemDetails?.poAttachments ? [...fleetItemDetails.poAttachments] : []})
    let alreadyLinkedattacment: any = []
      let obj: any = {}
      obj.fleetItemId = fleetItemDetails?.fleetRequestDetailId
      obj.attachments = fleetItemDetails?.poAttachments || []
      alreadyLinkedattacment.push(obj)
    dispatch(setLinkedAttachments([...(linkedAttachment || []), ...alreadyLinkedattacment]))
  }
}
useEffect(() => {
  if (fleetItemCancel?.fleetId && purchaseOrderStepperDataArr?.length) {
    if (purchaseOrderStepperData?.fleetRequestDetailId === fleetItemCancel?.fleetId) {
      let fleetItemCancelTemp = fleetItemCancel
      fleetItemCancelTemp.cancelComments = cancelComment
      setCancelComment('')
      dispatchStepperData({...purchaseOrderStepperData, ...fleetItemCancelTemp})
      dispatch(setOrderDetail({...orderDetails, orderStatus: fleetItemCancel.orderStatus}))
    }
    if (cancelledItemFleetId != 0 && cancelledItemFleetId !== undefined) {
      dispatchChangeLogs(parseInt(cancelledItemFleetId));
    }
  }
}, [fleetItemCancel])

const commonReturnsuccessPopup = (isLastItemReturned?: any) =>{
  let decriptionTxt = (
    <div>
      <p>{isLastItemReturned ? 'Order' : 'Item'} has been returned to requestor successfully.</p>
    </div>
  );
  setReturnsuccessPopupContent({
    ...returnSuccessPopupContent,
    titleImg: successBee,
    title: CONSTANTS.ORDER_STATUS.RETURNED,
    isDialogVisible: true,
    isTitleWarning: false,
    subtextcontent: decriptionTxt,
    outlineBtnText: "OK",
    popupOutlinebtnOnclick: () => {
      if(isLastItemReturned){
        dispatch(setFleetItemReturnToRequestor(null))
        if(pagename === CONSTANTS.PAGE_NAME.REQUISITION){
          navDispatch('Customer My Orders')
        } else if(pagename === CONSTANTS.PAGE_NAME.ASSET){
          navDispatch('Asset')
        } else{
          navDispatch('Home')
        } 
          dispatch(setOrderById({}))
          navigate('/ordermanagement');
      }else{
        const fleetIds = new Set(fleetItemReturn?.response?.items);
        const filteredFleetDetails = purchaseOrderStepperDataArr?.filter(
          (detail?: any) => fleetIds?.has(detail?.fleetRequestDetailId)
        );
        dispatch(setOrderDetail({...orderDetails, grandTotal: fleetItemReturn?.response?.totalAmount,  orderStatus: fleetItemReturn?.response?.orderStatus, quantity: fleetItemReturn?.response?.quantity}))
        dispatchStepperDataArr(filteredFleetDetails)
        dispatch(setFleetItemReturnToRequestor(null))
      }
      setReturnsuccessPopupContent({ ...returnSuccessPopupContent, isDialogVisible: false })
    },
    hideDialog: () => {
      setReturnsuccessPopupContent({ ...returnSuccessPopupContent, isDialogVisible: false })
    },
    isSingleConfirmationBtn: true,
});
}

useEffect(() => {
  if (fleetItemReturn?.isReturned && fleetItemReturn != null && fleetItemReturn?.hasOwnProperty('response') && purchaseOrderStepperDataArr?.length > 1 && purchaseOrderStepperData?.fleetRequestDetailId == fleetItemReturn?.fleetRequestDetailId) {
    commonReturnsuccessPopup(false)
  }else if(fleetItemReturn?.isReturned != null && fleetItemReturn?.response?.quantity == 0){
    commonReturnsuccessPopup(true)
  }
  else if(!fleetItemReturn?.isReturned && fleetItemReturn != null && purchaseOrderStepperData?.fleetRequestDetailId == fleetItemReturn?.fleetRequestDetailId){
    dispatch(setFleetItemReturnToRequestor(null))
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: "Error occured while Returning the Item.",
      outlineBtnText: "Close",
      isSingleConfirmationBtn: true,
    });
  }
}, [fleetItemReturn]);

  useEffect(()=> {
    if(fleetItemPurchaseDetails && purchaseOrderStepperDataArr?.length){
      // If vinSerialMismatch is null from API, compute it from vinSerial vs cipSerialNumber
      let details = fleetItemPurchaseDetails;
      if (details?.vinSerialMismatch === null && details?.pocipDetails?.cipUnitNumber !== undefined) {
        const vinValue = (details?.vinSerial ?? '').trim();
        const cipValue = (details?.pocipDetails?.cipSerialNumber ?? '').trim();
        const isMismatch = vinValue !== cipValue;
        details = { ...details, vinSerialMismatch: isMismatch };
      }
      updatePODetailsArray(details)
      originalVinSerialRef.current = fleetItemPurchaseDetails?.vinSerial || ''
    }
}, [fleetItemPurchaseDetails])

useEffect(() => {
  if (fleetItemVendorDetails && purchaseOrderStepperDataArr?.length) {
    updatePODetailsArray(fleetItemVendorDetails)
  }
}, [fleetItemVendorDetails])

useEffect(() => {
  if (fleetItemTaskDetails && purchaseOrderStepperDataArr?.length) {
    updatePODetailsArray(fleetItemTaskDetails)
  }
}, [fleetItemTaskDetails])

useEffect(() => {
  if (fleetItemPurchaseOrder && purchaseOrderStepperDataArr?.length) {
    updatePODetailsArray(fleetItemPurchaseOrder)
    if (fleetItemPurchaseOrder?.poDescription1?.length > 30) {
      setErrors((prev: any) => ({ ...prev, poDescription1: 'length-30' }));
    }
    if (fleetItemPurchaseOrder?.poDescription2?.length > 30) {
      setErrors((prev: any) => ({ ...prev, poDescription2: 'length-30' }));
    }
  }
}, [fleetItemPurchaseOrder])

useEffect(()=> {
    if(fleetItemDetails && purchaseOrderStepperDataArr?.length){
      updatePOItemDetails({...fleetItemDetails, createUniquePO: fleetItemDetails?.createUniquePO || purchaseOrderStepperData?.createUniquePO})
    }
}, [fleetItemDetails])

  useEffect(()=> {
    if(fleetItemVendorDetailsSave && purchaseOrderStepperDataArr?.length && purchaseOrderStepperData?.fleetRequestDetailId === fleetItemVendorDetailsSave?.fleetId){
      let purchaseOrderData = {
        ...purchaseOrderStepperData,
        isDealerVendorSave : fleetItemVendorDetailsSave?.isDealerVendorSave,
      };
      dispatchStepperData(purchaseOrderData);
      dispatchChangeLogs(
        purchaseOrderStepperData.fleetRequestDetailId
      );
      if(fleetItemVendorDetailsSave?.isDealerVendorSave){
        dispatch(getAssetItemStatusVendorDetail(purchaseOrderStepperData.fleetRequestDetailId))
      }
    }
}, [fleetItemVendorDetailsSave])

  useEffect(()=> {
    if(fleetItemPurchaseOrderSave && purchaseOrderStepperDataArr?.length && purchaseOrderStepperData?.fleetRequestDetailId === fleetItemPurchaseOrderSave?.fleetDetailId){

      let purchaseOrderData = {
        ...purchaseOrderStepperData,
        isPurchaseOrderSave : fleetItemPurchaseOrderSave?.isSaved,
      };
      dispatchStepperData(purchaseOrderData);
      dispatchChangeLogs(
        purchaseOrderStepperData.fleetRequestDetailId
      );
      if(fleetItemPurchaseOrderSave?.isSaved){
        dispatch(getAssetItemStatusPurchaseOrder(purchaseOrderStepperData?.fleetRequestDetailId))
        dispatch(getAssetItemStatusTaskDetail({ id: purchaseOrderStepperData?.fleetRequestDetailId, isRequisition: true }))
      }
    }
}, [fleetItemPurchaseOrderSave])

const isChangedAfterPoCreation = (val: any) =>{
  return purchaseOrderStepperData?.isChangedAfterPoCreation ? null : val
}

const isPurchaseDetailsSaveSuccess = () => {
  return fleetItemPurchaseDetailsSave?.success
}

const getUpdatedValueOnSuccess = (savedValue: any, currentValue: any) => {
  return isPurchaseDetailsSaveSuccess() ? (savedValue || currentValue) : currentValue
}

  useEffect(()=> {
    if(fleetItemPurchaseDetailsSave && purchaseOrderStepperDataArr?.length && purchaseOrderStepperData?.fleetRequestDetailId === fleetItemPurchaseDetailsSave?.fleetDetailId){

      // VIN duplicate: backend returned isDuplicateVin — show popup, do not run save success logic
      if (fleetItemPurchaseDetailsSave?.isDuplicateVin) {
        showVinDuplicatePopup(
          fleetItemPurchaseDetailsSave?.duplicateVinMessage,
          () => {
            if (lastDispatchedPayload.current) {
              const forcedPayload = { ...lastDispatchedPayload.current, forceVinSave: true };
              lastDispatchedPayload.current = forcedPayload;
              dispatch(getFleetItemPurchaseDetailsSave(forcedPayload));
            }
          }
          );
        // Clear Redux state immediately so tab switches don't re-show this popup
          dispatch(setFleetItemPurchaseDetailsSave(null));
        return; 
      }

      const isSaveSuccess = isPurchaseDetailsSaveSuccess();
      const isNonStandardEquip = purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.NON_STANDARD_EQUIPMENT;
      
      let purchaseOrderData = {
        ...purchaseOrderStepperData,
        isCipPoolSaved : purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cipUnitNumber'),
        isPurchaseDetailsSave : isSaveSuccess,
        assetNo : purchaseOrderStepperData?.assetNumber,
        vinSerial: getUpdatedValueOnSuccess(fleetItemPurchaseDetailsSave?.vinSerial, purchaseOrderStepperData?.vinSerial),
        vinSerialSource: getUpdatedValueOnSuccess(fleetItemPurchaseDetailsSave?.vinSerialSource, purchaseOrderStepperData?.vinSerialSource),
        vinValidationMessage: fleetItemPurchaseDetailsSave?.vinValidationMessage || '',
        vinSerialMismatch: isSaveSuccess ? (fleetItemPurchaseDetailsSave?.vinSerialMismatch ?? false) : purchaseOrderStepperData?.vinSerialMismatch,
        poNumber : isChangedAfterPoCreation(purchaseOrderStepperData?.poNumber),
        poCreationDate : isChangedAfterPoCreation(purchaseOrderStepperData?.poCreationDate),
        poDealerDetails: isChangedAfterPoCreation(purchaseOrderStepperData?.poDealerDetails),
        poCreatedDate: isChangedAfterPoCreation(purchaseOrderStepperData?.poCreatedDate),
        isVendorSameAsDealer: purchaseOrderStepperData?.isChangedAfterPoCreation ? false : purchaseOrderStepperData?.isVendorSameAsDealer,
        isChangedAfterPoCreation: false,
        poVendorDetails: isChangedAfterPoCreation(purchaseOrderStepperData?.poVendorDetails),
        pricePerUnit: (isSaveSuccess && isNonStandardEquip) ? formatPrice(fleetItemPurchaseDetailsSave?.pricePerUnit, 2) : purchaseOrderStepperData?.pricePerUnit,
        assetAfterSave: isSaveSuccess ? purchaseOrderStepperData?.assetNumber : purchaseOrderStepperData?.assetAfterSave,
      };
      dispatchChangeLogs(
        purchaseOrderStepperData.fleetRequestDetailId
      );
      dispatchStepperData(purchaseOrderData);
      if(skipVendorDetail){
        setIsVendorDetailSkippedOnSave(true)
      }else{
        setIsVendorDetailSkippedOnSave(false)
      }
      if(isSaveSuccess){
        let fleetItemHeaderDetailsTemp = fleetItemHeaderDetails ? JSON.parse(JSON.stringify(fleetItemHeaderDetails)) : null;
        fleetItemHeaderDetailsTemp?.map((item?: any, index?: any) => {
          if (item?.fleetRequestDetailId == fleetItemPurchaseDetailsSave?.fleetDetailId) {
              item.isCipPool = skipVendorDetail
          }
        })
        dispatch(setFleetItemHeaderDetail(fleetItemHeaderDetailsTemp));
        dispatch(getAssetItemStatusPurchaseOrder(purchaseOrderStepperData?.fleetRequestDetailId))
        dispatch(getAssetItemStatusVendorDetail(purchaseOrderStepperData?.fleetRequestDetailId))
        dispatch(getAssetItemStatusPurchaseDetails(purchaseOrderStepperData?.fleetRequestDetailId))
        dispatch(getFleetItemPurchaseDetails(purchaseOrderStepperData?.fleetRequestDetailId))
        dispatch(getAssetItemStatusTaskDetail({ id:purchaseOrderStepperData?.fleetRequestDetailId, isRequisition: true }))
        dispatch(setVinValidationResult(null));
        originalVinSerialRef.current = purchaseOrderData?.vinSerial
      }
    }
}, [fleetItemPurchaseDetailsSave])

  useEffect(() => {
    if (SavedAdminTaskValue?.fleetItemlId && purchaseOrderStepperData?.fleetRequestDetailId == SavedAdminTaskValue?.fleetItemlId) {
      dispatch(getAssetItemStatusTaskDetail({ id: SavedAdminTaskValue?.fleetItemlId, isRequisition: true }))
      dispatchChangeLogs(SavedAdminTaskValue?.fleetItemlId);
      const stepperDataTemp: any = {}
      stepperDataTemp.poFleetRequestTaskListTrackings = SavedAdminTaskValue.taskList
      stepperDataTemp.assignedTo = SavedAdminTaskValue.assignedTo
      stepperDataTemp.estDeliveryDate = SavedAdminTaskValue.estDeliveryDate
      stepperDataTemp.itemStatus = SavedAdminTaskValue.itemStatus
      stepperDataTemp.fleetStatus = SavedAdminTaskValue.fleetStatus
      stepperDataTemp.orderStatus = SavedAdminTaskValue.orderStatus
      delete SavedAdminTaskValue.taskList
      dispatchStepperData({...purchaseOrderStepperData, ...stepperDataTemp})
      dispatch(setOrderDetail({...orderDetails, orderStatus: SavedAdminTaskValue.orderStatus}))
    }
  }, [SavedAdminTaskValue])

  useEffect(()=>{
    if(isItemSaved?.isItemSaved && isItemSaved?.fleetId === purchaseOrderStepperData?.fleetRequestDetailId){
        dispatch(getFleetItemDetails(isItemSaved?.fleetId))
    }
  }, [isItemSaved])
  
  const popUpMessage = (decriptionTxt: any) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "Close",
      isSingleConfirmationBtn: true,
    });
  }


  const StepperOneClick = (e: any) => {
    if ((!purchaseOrderStepperData?.isPurchaseDetailsSave || !purchaseOrderStepperData?.isPurchaseOrderSave || !purchaseOrderStepperData?.isDealerVendorSave)) {
      let decriptionTxt = (
        <p>{"Please save this order before continue order further."}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }
    commonStepperOneOnClick(setActiveStepper, activeStepper, StepperRef)
    StepperRef?.current?.classList.remove("enable");
    StepperRef?.current?.classList.add("enable-bothbtn");
    dispatch(getFleetItemPurchaseDetails(purchaseOrderStepperData?.fleetRequestDetailId))
    dispatch(setVinValidationResult(null));
    originalVinSerialRef.current = ''
  }

  const StepperTwoClick = (e: any) => {
    if (!purchaseOrderStepperData?.isPurchaseDetailsSave || !purchaseOrderStepperData?.isPurchaseOrderSave || !purchaseOrderStepperData?.isDealerVendorSave) {
      let decriptionTxt = (
        <p>{"Please save this order before continue order further."}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }
    if(activeStepper <= 2){
    if (!hasValidPurchaseDetails()) {
      let decriptionTxt = (
        <p>{"Please Provide the required information before continue order further."}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }
  }

    if(skipVendorDetail){
      dispatch(getFleetItemTaskDetails(purchaseOrderStepperData?.fleetRequestDetailId))
    }else{
      dispatch(getFleetItemVendorDetails(purchaseOrderStepperData?.fleetRequestDetailId))
    }
    commonStepperTwoOnclick(setActiveStepper, activeStepper, StepperRef)
    StepperRef?.current?.classList.remove("enable");
    StepperRef?.current?.classList.add("enable-bothbtn");
  }

  const StepperThreeClick = (e: any) => {   
    if (!purchaseOrderStepperData?.isPurchaseDetailsSave || !purchaseOrderStepperData?.isPurchaseOrderSave || !purchaseOrderStepperData?.isDealerVendorSave) {
      let decriptionTxt = (
        <p>{"Please save this order before continue order further."}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }
    if(activeStepper <= 3){
    if ( !hasValidPurchaseDetails()) {
      let decriptionTxt = (
        <p>{"Please Provide the Purchase Details before continue order further."}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }
    if (!hasValidVendorDetails()) {
      let decriptionTxt = (
        <p>{`Please Provide the ${isBulkOrder ? "Vendor" : "Dealer"} Details before continue order further.`}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }
    if ((!hasValidSameVendorDetails() && !isBulkOrder) && !purchaseOrderStepperData?.isVendorSameAsDealer) {
      let decriptionTxt = (
        <p>{"Please Provide the Vendor Details before continue order further."}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }
  }
    dispatch(getFleetItemPurchaseOrder(purchaseOrderStepperData.fleetRequestDetailId))
    commonStepperThreeOnClick(setActiveStepper, activeStepper, StepperRef)
    StepperRef?.current?.classList.remove("enable");
    StepperRef?.current?.classList.add("enable-bothbtn");
  }

  const StepperFourClick = (e: any) => {
    if (!purchaseOrderStepperData?.isPurchaseDetailsSave || !purchaseOrderStepperData?.isPurchaseOrderSave || !purchaseOrderStepperData?.isDealerVendorSave) {
      let decriptionTxt = (
        <p>{"Please save this order before continue order further."}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }
    if(activeStepper <= 4){
    if (purchaseOrderStepperData?.isPurchaseDetailsSave && !hasValidPurchaseDetails()) {
      let decriptionTxt = (
        <p>{"Please Provide the Purchase Details before continue order further."}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }
    if (!hasValidVendorDetails()) {
      let decriptionTxt = (
        <p>{`Please Provide the ${isBulkOrder ? "Vendor" : "Dealer"} Details before continue order further.`}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }

    if ((!hasValidSameVendorDetails() && !isBulkOrder) && !purchaseOrderStepperData?.isVendorSameAsDealer) {
      let decriptionTxt = (
        <p>{"Please Provide the Vendor Details before continue order further."}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }

    if (!hasValidPurchaseOrderDetails()) {
      let decriptionTxt = (
        <p>{"Please Provide the Purchase Order before continue order further."}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }
  }

    if (itemDetails?.poNumber == null) {
      let decriptionTxt = (
        <p>{"Please Provide the Po Number before continue order further."}</p>
      );
      popUpMessage(decriptionTxt)
      return
    }

    dispatch(getFleetItemTaskDetails(purchaseOrderStepperData?.fleetRequestDetailId))
    commonStepperFourOnClick(setActiveStepper, activeStepper, StepperRef)
  }

  useEffect(() => {
    if(isShowComplete(itemDetails?.itemStatus) && activeStepper == 2 && itemDetails?.pocipDetails){
      StepperRef?.current?.children[activeStepper - 1]?.classList.remove("active");
      StepperRef?.current?.children[activeStepper - 1]?.classList.add("completed");
     }
    else if((!isShowComplete(itemDetails?.itemStatus) && activeStepper == 2 && itemDetails?.pocipDetails)){
      StepperRef?.current?.children[activeStepper - 1].classList.add("active");
    }
    else if((activeStepper == 2 && !itemDetails?.pocipDetails)){
      StepperRef?.current?.children[activeStepper - 1].classList.add("active");
    }
    else if(isShowComplete(itemDetails?.itemStatus) && activeStepper == 4){
      StepperRef?.current?.children[activeStepper - 1]?.classList.remove("active");
      StepperRef?.current?.children[activeStepper - 1]?.classList.add("completed");
    }
    else if((!isShowComplete(itemDetails?.itemStatus) && activeStepper == 4)){
      StepperRef?.current?.children[activeStepper - 1].classList.add("active");
    }
  }, [activeStepper, savedStatus])

  const stepperListData: Array<any> =
    !skipVendorDetail
      ? [
        {
          text: "Purchase Detail",
          step: "1",
          onClick: StepperOneClick
        },
        {
          text: isBulkOrder ? 'Vendor Detail' : "Dealer Detail",
          step: "2",
          onClick: StepperTwoClick
        },
        {
          text: "Purchase Order",
          step: "3",
          onClick: StepperThreeClick
        },
        {
          text: "Tasks",
          step: "4",
          onClick: StepperFourClick
        },
      ]
      : [
        {
          text: "Purchase Detail",
          step: "1",
          onClick: StepperOneClick
        },
        {
          text: "Tasks",
          step: "2",
          onClick: StepperTwoClick
        },
      ];

  useEffect(() => {
    if (fleetItemDetails?.fleetRequestDetailId === purchaseOrderStepperData?.fleetRequestDetailId) {
      setActiveStepper(parseInt(purchaseOrderStepperData?.stepNumber))
      if (purchaseOrderStepperData?.stepNumber == "1") {
        dispatch(getFleetItemPurchaseDetails(purchaseOrderStepperData?.fleetRequestDetailId))
        originalVinSerialRef.current = ''
      } else if (purchaseOrderStepperData?.stepNumber == "2") {
        if (purchaseOrderStepperData?.isCipPool) {
          dispatch(getFleetItemTaskDetails(purchaseOrderStepperData?.fleetRequestDetailId))
        } else {
          dispatch(getFleetItemVendorDetails(purchaseOrderStepperData?.fleetRequestDetailId))
        }
      } else if (purchaseOrderStepperData?.stepNumber == "3") {
        dispatch(getFleetItemPurchaseOrder(purchaseOrderStepperData?.fleetRequestDetailId))
      } else if (purchaseOrderStepperData?.stepNumber == "4") {
        dispatch(getFleetItemTaskDetails(purchaseOrderStepperData?.fleetRequestDetailId))
      }
    }
  }, [fleetItemDetails])

  const [clickPickPoolBtn, setClickPoolBtn] = useState<any>(false)
  useEffect(() => {
    if (itemDetails) {
      if (itemDetails?.assetNumber) {
        setActiveStepper(2);
        if (itemDetails?.poDealerDetails?.vendorABNumber && itemDetails?.poDealerDetails?.dealerName && itemDetails?.poDealerDetails?.dealerAdd1 && itemDetails?.poDealerDetails?.dealerState &&
          itemDetails?.poDealerDetails?.dealerZip && itemDetails?.poDealerDetails?.dealerPhone && itemDetails?.estDeliveryDate) {
          setActiveStepper(3);
          if (itemDetails?.poNumber) {
            setActiveStepper(4);
          }
          else {
            StepperRef?.current?.children[3]?.classList.add(
              "next"
            );
          }
        }
        else {
          StepperRef?.current?.children[2]?.classList.add(
            "next"
          );
        }
      }
      else {
        StepperRef?.current?.children[1]?.classList.add(
          "next"
        );
      }      
      if (itemDetails.isCipPool) {
        setSkipVendorDetail(true);
        setIsVendorDetailSkippedOnSave(true)
      }
      if (activeStepper == 3) {
        StepperRef?.current?.classList.remove("enable-bothbtn");
        StepperRef?.current?.classList.add("enable");
      }
      if (activeStepper == 1 && activeStepper < stepperListData.length) {
        StepperRef?.current?.classList.add("enable");
        StepperRef?.current?.classList.add("enable-bothbtn");
      }
      setList(itemDetails?.poAttachments)
      setUploadedList(itemDetails?.poAttachments)
    }
  }, []);

  useEffect(()=>{
 
     if(skipVendorDetail === true && clickPickPoolBtn === true){
      StepperRef?.current?.children[1].classList.add(
        "next"
      );
    }    
  }, [skipVendorDetail])

  const hasValidPurchaseDetails = () => {
    setErrors({
      assetNumber: !purchaseOrderStepperData.assetNumber,
      assetValidationText: "Asset Number is required",
      pricePerUnit: !purchaseOrderStepperData.pricePerUnit,
      descriptionError: !purchaseOrderStepperData.descriptionId?.value ? "Description is required" : "",
      vinSerial: purchaseOrderStepperData?.vinSerial?.length > 30 ? "Please enter vin/Serial Number less than 30 character" : "",
      ...errors
    });
    if(!purchaseOrderStepperData.assetNumber){
      dispatchStepperData({...purchaseOrderStepperData, validationMessage: "Asset Number is required", assetIsValid:false})
    }
    else{
      dispatchStepperData({...purchaseOrderStepperData, validationMessage: "", assetIsValid:false})
    }
     return !!purchaseOrderStepperData.assetNumber && 
    !!purchaseOrderStepperData.pricePerUnit &&
    (purchaseOrderStepperData?.pricePerUnit?.length <= 15) &&  
    parseFloat(getOnlyNumbers(purchaseOrderStepperData?.pricePerUnit)) > 0 &&
    ((purchaseOrderStepperData?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT || purchaseOrderStepperData?.pocipDetails?.cipDesc) ? true : !!purchaseOrderStepperData?.descriptionId?.value) &&
    (!purchaseOrderStepperData?.vinSerial || purchaseOrderStepperData?.vinSerial?.length <= 30)
  };

  const hasValidVendorDetails = () => {
    setErrors({
      vendorABNumber:
        !purchaseOrderStepperData?.poDealerDetails?.vendorABNumber,
      dealerName: !purchaseOrderStepperData?.poDealerDetails?.dealerName || purchaseOrderStepperData?.poDealerDetails?.dealerName?.length > 50,
      dealerAdd1: !purchaseOrderStepperData?.poDealerDetails?.dealerAdd1 || purchaseOrderStepperData?.poDealerDetails?.dealerAdd1?.length > 50,
      dealerAdd2: purchaseOrderStepperData?.poDealerDetails?.dealerAdd2?.length > 50,
      dealerAdd3: purchaseOrderStepperData?.poDealerDetails?.dealerAdd3?.length > 50,
      dealerState: !purchaseOrderStepperData?.poDealerDetails?.dealerState || purchaseOrderStepperData?.poDealerDetails?.dealerState?.length > 2,
      dealerCity: !purchaseOrderStepperData?.poDealerDetails?.dealerCity || purchaseOrderStepperData?.poDealerDetails?.dealerCity?.length > 50,
      dealerZip: !purchaseOrderStepperData?.poDealerDetails?.dealerZip || purchaseOrderStepperData?.poDealerDetails?.dealerZip?.length > 12,
      dealerPhone: !purchaseOrderStepperData?.poDealerDetails?.dealerPhone || !isValidPhone(purchaseOrderStepperData?.poDealerDetails?.dealerPhone),
      estDeliveryDate: !purchaseOrderStepperData?.estDeliveryDate,
      dealerContactEmail: !purchaseOrderStepperData?.poDealerDetails?.dealerContactEmail || isEmail(purchaseOrderStepperData?.poDealerDetails?.dealerContactEmail) || purchaseOrderStepperData?.poDealerDetails?.dealerContactEmail?.length > 100
    });
    return (
      !!purchaseOrderStepperData.poDealerDetails &&
      !!purchaseOrderStepperData.poDealerDetails.vendorABNumber &&
      !!purchaseOrderStepperData.poDealerDetails.dealerName &&
      purchaseOrderStepperData?.poDealerDetails?.dealerName?.length <= 50 &&
      !!purchaseOrderStepperData.poDealerDetails.dealerAdd1 &&
      purchaseOrderStepperData?.poDealerDetails?.dealerAdd1?.length <= 50 &&
      (purchaseOrderStepperData?.poDealerDetails?.dealerAdd2 ?? "")?.length <= 50 &&
      (purchaseOrderStepperData?.poDealerDetails?.dealerAdd3 ?? "")?.length <= 50 &&
      !!purchaseOrderStepperData.poDealerDetails.dealerState &&
      purchaseOrderStepperData?.poDealerDetails?.dealerState?.length <= 2 &&
      !!purchaseOrderStepperData.poDealerDetails.dealerZip &&
      purchaseOrderStepperData?.poDealerDetails?.dealerZip?.length <= 12 &&
      !!purchaseOrderStepperData.poDealerDetails.dealerPhone &&
      isValidPhone(purchaseOrderStepperData?.poDealerDetails?.dealerPhone) &&
      !!purchaseOrderStepperData.poDealerDetails.dealerCity &&
      purchaseOrderStepperData?.poDealerDetails?.dealerCity?.length <= 50 &&
      !!purchaseOrderStepperData?.poDealerDetails?.dealerContactEmail &&
      !isEmail(purchaseOrderStepperData?.poDealerDetails?.dealerContactEmail) &&
      purchaseOrderStepperData?.poDealerDetails?.dealerContactEmail?.length <= 100
    );
  };

  const hasValidSameVendorDetails = () => {
    setErrors({
      vendorAbNumber: !purchaseOrderStepperData?.poVendorDetails?.vendorAbNumber,
      vendorName: !purchaseOrderStepperData?.poVendorDetails?.vendorName || purchaseOrderStepperData?.poVendorDetails?.vendorName?.length > 50,
      vendorAdd1: !purchaseOrderStepperData?.poVendorDetails?.vendorAdd1 || purchaseOrderStepperData?.poVendorDetails?.vendorAdd1?.length > 50,
      vendorAdd2: (purchaseOrderStepperData?.poVendorDetails?.vendorAdd2 ?? "")?.length > 50,
      vendorState: !purchaseOrderStepperData?.poVendorDetails?.vendorState || purchaseOrderStepperData?.poVendorDetails?.vendorState?.length > 2,
      vendorCity: !purchaseOrderStepperData?.poVendorDetails?.vendorCity || purchaseOrderStepperData?.poVendorDetails?.vendorCity?.length > 50,
      vendorZip: !purchaseOrderStepperData?.poVendorDetails?.vendorZip || purchaseOrderStepperData?.poVendorDetails?.vendorZip?.length > 12,
      vendorContactEmail: purchaseOrderStepperData?.poVendorDetails?.vendorContactEmail?.length > 0 ? (isEmail(purchaseOrderStepperData?.poVendorDetails?.vendorContactEmail) || purchaseOrderStepperData?.poVendorDetails?.vendorContactEmail?.length > 100) : false
    });
    return (
      purchaseOrderStepperData.poVendorDetails &&
      purchaseOrderStepperData.poVendorDetails.vendorAbNumber &&
      purchaseOrderStepperData.poVendorDetails.vendorName &&
      purchaseOrderStepperData?.poVendorDetails?.vendorName?.length <= 50 &&
      purchaseOrderStepperData.poVendorDetails.vendorAdd1 &&
      purchaseOrderStepperData?.poVendorDetails?.vendorAdd1?.length <= 50 &&
      (purchaseOrderStepperData?.poVendorDetails?.vendorAdd2 ?? "")?.length <= 50 &&
      purchaseOrderStepperData.poVendorDetails.vendorState &&
      purchaseOrderStepperData?.poVendorDetails?.vendorState?.length <= 2 &&
      purchaseOrderStepperData.poVendorDetails.vendorCity &&
      purchaseOrderStepperData?.poVendorDetails?.vendorCity?.length <= 50 &&
      purchaseOrderStepperData.poVendorDetails.vendorZip &&
      purchaseOrderStepperData?.poVendorDetails?.vendorZip?.length <= 12 &&
      (purchaseOrderStepperData?.poVendorDetails?.vendorContactEmail ? (!isEmail(purchaseOrderStepperData?.poVendorDetails?.vendorContactEmail) && purchaseOrderStepperData?.poVendorDetails?.vendorContactEmail?.length <= 100) : true)
    );
  };

  const hasValidPurchaseOrderDetails = () => {
    setErrors({
      poDescription1: !purchaseOrderStepperData.poDescription1,
      glaccountNumber: !purchaseOrderStepperData.glaccountNumber
    });
    return !!purchaseOrderStepperData.poDescription1 && !!purchaseOrderStepperData.glaccountNumber;
  };

  const checkValidity = () => {
    let value;
    if (activeStepper === 1) {
      value = hasValidPurchaseDetails();
      if (!value) return value;
      if (needToCallReset()) {
        dispatchSetError({
          showAlert: true,
          type: "warning",
          text: "Please save this order before continue order further.",
          itemNumber: +String(itemDetails.itemId).split("-")[1],
        });

        setTimeout(() => {
          dispatchSetError(undefined);
        }, 5000);

        return false;
      }
    } else if (activeStepper === 2 && purchaseOrderStepperData?.isVendorSameAsDealer) {
      value = hasValidVendorDetails();
    }
    else if (activeStepper === 2 && !purchaseOrderStepperData?.isVendorSameAsDealer) {
      value = hasValidVendorDetails() && (hasValidSameVendorDetails() || isBulkOrder) ? true : false;
    } else if (activeStepper === 3) {
      value = hasValidPurchaseOrderDetails();
    } else if (activeStepper === 4) {
      value = true;
    }
    return value;
  };


  const nextSection = () => {
    setErrors({});
    dispatchStepperData({...purchaseOrderStepperData, validationMessage: "", assetIsValid: undefined})
        if (activeStepper !== stepperListData.length) {
          setActiveStepper((prev) => prev + 1);
          StepperRef?.current?.children[activeStepper + 1].classList.add(
            "next"
          );
          StepperRef?.current?.children[activeStepper].classList.remove(
            "next"
          );
        }
        if (activeStepper == 3 || (activeStepper == 1 && skipVendorDetail)) {

          StepperRef?.current?.classList.remove("enable-bothbtn");
          StepperRef?.current?.classList.add("enable");
        }
        if (
          activeStepper == 1 &&
          activeStepper < stepperListData.length &&
          !skipVendorDetail
        ) {
          StepperRef?.current?.classList.add("enable");
          StepperRef?.current?.classList.add("enable-bothbtn");
        }
  }

  const commonSavePaload = (isConsolidatedFleetIds: any) => {
    return {
      fleetRequestDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
      savedBy: userDetails?.emailId,
      purchaseType: purchaseOrderStepperData?.purchaseType,
      pricePerUnit: purchaseOrderStepperData?.pricePerUnit ? parseFloat(getOnlyNumbers(purchaseOrderStepperData?.pricePerUnit)) : 0,
      popricePerUnit: purchaseOrderStepperData?.popricePerUnit ? parseFloat(getOnlyNumbers(purchaseOrderStepperData?.popricePerUnit)) : 0,
      pocipDetails: purchaseOrderStepperData?.pocipDetails,
      assetNumber: purchaseOrderStepperData?.assetNumber || null,
      orderTypeId: purchaseOrderStepperData?.orderTypeId,
      assetSourcing: purchaseOrderStepperData?.assetSourcing,
      poDescription1: purchaseOrderStepperData?.poDescription1,
      poDescription2: purchaseOrderStepperData?.poDescription2,
      description: purchaseOrderStepperData?.description,
      make: purchaseOrderStepperData?.make,
      model: purchaseOrderStepperData?.model,
      assetModelId: purchaseOrderStepperData?.assetModelId,
      isLicensedTitled: purchaseOrderStepperData?.isLicensedTitled,
      isCIPOrder: purchaseOrderStepperData?.isCIPOrder,
      createUniquePO: purchaseOrderStepperData?.createUniquePO,
      barcodeNo: purchaseOrderStepperData?.barcodeNo,
      year: purchaseOrderStepperData?.year,
      vinSerial: purchaseOrderStepperData?.vinSerial,
      vinSerialSource: purchaseOrderStepperData?.vinSerialSource || null,
      isVinUpdated: purchaseOrderStepperData?.isVinUpdated || false,
      forceVinSave: false,
      consolidatedFleetIds: isConsolidatedFleetIds ? purchaseOrderStepperDataArr
      ?.filter(
        (item: any) =>
          item.orderRequestType === purchaseOrderStepperData?.orderRequestType &&
          !item.poNumber &&
          !item.pocipDetails &&
          item.fleetRequestDetailId !== purchaseOrderStepperData?.fleetRequestDetailId
      )
      .map((item: any) => item.fleetRequestDetailId) : null
    }
  }

  // Validate critical fields before saving
    const validateNullFields = (payload: any) => {
    const notNullFields = [
      { key: 'assetSourcing', value: payload.assetSourcing },
      { key: 'orderTypeId', value: payload.orderTypeId },
      { key: 'isLicensedTitled', value: payload.isLicensedTitled},
      { key: 'purchaseType', value: payload.purchaseType }
      ];

      const hasNullFields = notNullFields.some(field => 
      field.value === null || field.value === undefined || field.value === ''
      );
    return !hasNullFields;
  };

  // Show validation warning popup and refresh item details on close
  const showValidationWarning = () => {
    let decriptionTxt = (
        <>
          <p>Some details were not loaded properly.  Please select ‘OK’ to refresh and then select Save again.</p>
        </>
      );
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "INFORMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "OK",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false });
        // Refresh all item details to reload data from database
        dispatch(getFleetItemHeaderDetail(orderDetails?.orderRequestId))
        dispatch(getFleetItemDetails(purchaseOrderStepperData?.fleetRequestDetailId));
        dispatch(getFleetItemPurchaseDetails(purchaseOrderStepperData?.fleetRequestDetailId));
      },
      hideDialog: () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false });
        // Refresh all item details to reload data from database
        dispatch(getFleetItemHeaderDetail(orderDetails?.orderRequestId))
        dispatch(getFleetItemPurchaseDetails(purchaseOrderStepperData?.fleetRequestDetailId));
        dispatch(getFleetItemDetails(purchaseOrderStepperData?.fleetRequestDetailId));
      }
    });
  };

  useEffect(() => {
    if(assetValidation?.length > 0){
    if(purchaseOrderStepperData.itemId == itemId && !purchaseOrderStepperData.createUniquePO){
      if(assetValidation?.length > 0){
        dispatch(setFleetAssetValidation([]))
        dispatchStepperData({...purchaseOrderStepperData, assetIsValid: assetValidation[0]?.isValid, validationMessage: assetValidation[0]?.validationMessage})
        if(assetValidation[0]?.isValid){
          let payload = commonSavePaload(false)
            if (!validateNullFields(payload)) {
            showValidationWarning();
            return;
          }
          lastDispatchedPayload.current = payload;
          dispatch(getFleetItemPurchaseDetailsSave(payload))
        }
      }
    }
    if(purchaseOrderStepperData.itemId == itemId && purchaseOrderStepperData.createUniquePO){
      dispatch(setFleetAssetValidation([]))
    let validatedItems: any = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
    
    let inValidAssets: any = []

    assetValidation?.map((item: any) => {
      validatedItems = validatedItems?.map((val: any) => {
        if(item?.assetNumber == val?.assetNumber){
          if(item?.validationMessage){
            inValidAssets.push(val?.itemId)
          }
          return {...val, assetIsValid: item?.isValid, validationMessage: item?.validationMessage}
        }
        else{
          return{...val}
        }
      })
      dispatchStepperDataArr(validatedItems)      
    })
    if(inValidAssets?.length == 0){
      let payload = commonSavePaload(true)
      if (!validateNullFields(payload)) {
        showValidationWarning();
        return;
      }
      lastDispatchedPayload.current = payload;
      dispatch(getFleetItemPurchaseDetailsSave(payload))
    }
    else{
      let decriptionTxt = (
        <>
          <p>Please enter the valid asset in items {`${inValidAssets}`} before saving.</p>
        </>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
      });
    }
  }
}
  },[assetValidation])

  const stepperScrollTopFun = () => {
    setTimeout(() => {
      const elem = document.getElementsByClassName(`purchaseorder-stepper_${accordionIndex}`)[0] as HTMLElement;
      const top = elem?.offsetTop;
      if (window.innerWidth < 600) {
        document.getElementsByClassName('content-wrapper')[0].scrollTop = top + 500
      }
      else {
        document.getElementsByClassName('content-wrapper')[0].scrollTop = top + 200
      }
    }, 100)
  }

  const purchaseDetailFieldsCheck = () => {
    return hasValidPurchaseDetails() && purchaseOrderStepperData?.isPurchaseDetailsSave
  }

  const dealerDetailFieldsCheck = () => {
    return  (hasValidVendorDetails() && purchaseOrderStepperData?.isDealerVendorSave)
  }
  const vendorDetailFieldsCheck = () => {
    return ((itemDetails?.poVendorDetails?.vendorAbNumber == purchaseOrderStepperData?.poVendorDetails?.vendorAbNumber &&
      itemDetails?.poVendorDetails?.vendorName == purchaseOrderStepperData?.poVendorDetails?.vendorName &&
      itemDetails?.poVendorDetails?.vendorEmailAddress == purchaseOrderStepperData?.poVendorDetails?.vendorEmailAddress &&
      itemDetails?.poVendorDetails?.vendorAdd1 == purchaseOrderStepperData?.poVendorDetails?.vendorAdd1 &&
      itemDetails?.poVendorDetails?.vendorAdd2 == purchaseOrderStepperData?.poVendorDetails?.vendorAdd2 &&
      itemDetails?.poVendorDetails?.vendorState == purchaseOrderStepperData?.poVendorDetails?.vendorState &&
      itemDetails?.poVendorDetails?.vendorCity == purchaseOrderStepperData?.poVendorDetails?.vendorCity &&
      itemDetails?.poVendorDetails?.vendorZip == purchaseOrderStepperData?.poVendorDetails?.vendorZip) || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED)
  }

  const purchaseOrderDetailFieldsCheck = () => {
    return (hasValidPurchaseOrderDetails() && purchaseOrderStepperData?.isPurchaseOrderSave)
  }

  const handleClickNext = () => {
    if (!errors?.poDescription1 && !errors?.barcodeNo && !errors?.glaccountNumber && !errors?.comment) {
      if (purchaseOrderStepperData?.itemStatus != CONSTANTS.ORDER_STATUS.CANCELLED) {
        if (!checkValidity()) {
          return;
        }
      }
      if (activeStepper == 1 && purchaseDetailFieldsCheck()) {
        nextSection()
        if(skipVendorDetail){
          dispatch(getFleetItemTaskDetails(purchaseOrderStepperData?.fleetRequestDetailId))
        } else {
          dispatch(getFleetItemVendorDetails(purchaseOrderStepperData?.fleetRequestDetailId))
        }
      }
      else if (activeStepper == 2 && dealerDetailFieldsCheck() && purchaseOrderStepperData?.isVendorSameAsDealer) {
        nextSection()
        dispatch(getFleetItemPurchaseOrder(purchaseOrderStepperData?.fleetRequestDetailId))
      } else if (activeStepper == 2 && dealerDetailFieldsCheck() && !purchaseOrderStepperData?.isVendorSameAsDealer && (vendorDetailFieldsCheck() || isBulkOrder)) {
        nextSection()
        dispatch(getFleetItemPurchaseOrder(purchaseOrderStepperData?.fleetRequestDetailId))
      } else if (activeStepper == 3 && purchaseOrderDetailFieldsCheck()) {
        if (itemDetails.poNumber) {
          nextSection()
          dispatch(getFleetItemTaskDetails(purchaseOrderStepperData?.fleetRequestDetailId))
        } else if (purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED) {
          nextSection()
          dispatch(getFleetItemTaskDetails(purchaseOrderStepperData?.fleetRequestDetailId))
        } else {
          dispatchSetError({
            showAlert: true,
            type: "warning",
            text: "Please create PO before continue order further.",
            itemNumber: +String(itemDetails?.itemId).split("-")[1],
          });
          setTimeout(() => {
            dispatchSetError(undefined);
          }, 5000);
        }
      }
      else {
        dispatchSetError({
          showAlert: true,
          type: "warning",
          text: "Please save this order before continue order further.",
          itemNumber: +String(itemDetails?.itemId).split("-")[1],
        });

        setTimeout(() => {
          dispatchSetError(undefined);
        }, 5000);
      }
      stepperScrollTopFun()
    }
  };

  const handleClickPrevious = () => {
    StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
    if (activeStepper > 1) {
      if (activeStepper === 3 && skipVendorDetail) {
        StepperRef?.current?.children[activeStepper - 2].classList.remove(
          "completed"
        );
        StepperRef?.current?.children[activeStepper - 3].classList.add(
          "active"
        );
        StepperRef?.current?.children[activeStepper - 3].classList.remove(
          "completed"
        );
      } else {
        StepperRef?.current?.children[activeStepper - 2].classList.add(
          "active"
        );
        StepperRef?.current?.children[activeStepper - 2].classList.remove(
          "completed"
        );
        StepperRef?.current?.children[activeStepper - 1].classList.add(
          "next"
        );
        StepperRef?.current?.children[activeStepper].classList.remove(
          "next"
        );
        StepperRef?.current?.children[activeStepper - 1].classList.remove(
          "completed"
        );
      }
      StepperRef?.current?.classList.add("enable-bothbtn");
    }

    if (skipVendorDetail && activeStepper === 2) {
      StepperRef?.current?.classList.remove("enable");
      StepperRef?.current?.classList.add("enable-bothbtn");
    }
    if (activeStepper > 1) {
      setActiveStepper((prev) => prev - 1);
    }

    if(activeStepper === 4){
      dispatch(getFleetItemPurchaseOrder(purchaseOrderStepperData?.fleetRequestDetailId))
    } else if(activeStepper === 3){
      dispatch(getFleetItemVendorDetails(purchaseOrderStepperData?.fleetRequestDetailId))
    } else {
      dispatch(getFleetItemPurchaseDetails(purchaseOrderStepperData?.fleetRequestDetailId))
    }
    stepperScrollTopFun()
  };

  useEffect(() => {
    if (itemDetails?.fleetRequestDetailId && !isSavePurchaseOrderLoading && isSavePurchaseOrderLoading != undefined) {
      dispatchChangeLogs(
        itemDetails?.fleetRequestDetailId
      );
    }
  }, [isSavePurchaseOrderLoading])

  const needToCallReset = () =>
    itemDetails?.assetSourcing !== purchaseOrderStepperData?.assetSourcing ||
      (itemDetails?.purchaseType !== purchaseOrderStepperData?.purchaseType &&
        !(
          itemDetails?.purchaseType?.includes("Lease") &&
          purchaseOrderStepperData?.purchaseType?.includes("Lease")
      )) || !purchaseOrderStepperData?.isPurchaseDetailsSave


      const handleBlurChange = () => {
    if (activeStepper == 1) {
      let isDuplicate = false
      let duplicateItemsArr: any = []
      let count =0
      purchaseOrderStepperDataArr?.map((item: any) => {
        if(item.assetNumber == purchaseOrderStepperData?.assetNumber && item?.assetNumber)
          count++;
       })
      purchaseOrderStepperDataArr?.map((item : any) => {
        if(item?.itemId != purchaseOrderStepperData?.itemId){
          if(item?.assetNumber && purchaseOrderStepperData?.assetNumber && item?.assetNumber == purchaseOrderStepperData?.assetNumber){
            duplicateItemsArr.push({...item, validationMessage:"The Asset # you have entered is already associated with other item. Please enter a new asset number that is not been associated."})
            setErrors({
              assetNumber: true,
              assetValidationText: "The Asset # you have entered is already associated with other item. Please enter a new asset number that is not been associated."
            });
            isDuplicate = true
          }
          else{
            duplicateItemsArr.push({...item, validationMessage:""})
          }
        }
        else if(count> 1 && item?.itemId == purchaseOrderStepperData?.itemId){
          duplicateItemsArr.push({...item, validationMessage:"The Asset # you have entered is already associated with other item. Please enter a new asset number that is not been associated."})
        }
        else{
          duplicateItemsArr.push({...item, validationMessage:""})
        }
      })
      dispatchStepperDataArr(duplicateItemsArr)
      if(isDuplicate){
        return;
      }
      if(itemDetails?.assetNumber != purchaseOrderStepperData?.assetNumber && !purchaseOrderStepperData?.pocipDetails){
        dispatch(setFleetItemId(purchaseOrderStepperData?.itemId))
      }
    }
  }


  const saveDealerVendorDetails = () => {
      const payload = {
        fleetRequestDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
        savedBy: userDetails?.emailId,
        poVendorDetails: {
          ...purchaseOrderStepperData?.poVendorDetails,
          fleetRequestVendorId: purchaseOrderStepperData?.poVendorDetails?.fleetRequestVendorId || 0
        },
        poDealerDetails: {
          ...purchaseOrderStepperData?.poDealerDetails,
          fleetRequestDealerId: purchaseOrderStepperData?.poDealerDetails?.fleetRequestDealerId || 0
        },
        isVendorSameAsDealer: purchaseOrderStepperData?.isVendorSameAsDealer,
        consolidatedFleetIds: null
      }

      if(purchaseOrderStepperData?.createUniquePO){
        const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
        let consolidatedPo: any = []
        saveConsolidatedPoDataArr?.map((item: any) => {
          if (purchaseOrderStepperData?.orderRequestType === item?.orderRequestType && item?.fleetRequestDetailId !== purchaseOrderStepperData?.fleetRequestDetailId && !item.poNumber && !item.pocipDetails) {
            consolidatedPo.push(item?.fleetRequestDetailId)
          }
        })
        payload.consolidatedFleetIds = consolidatedPo
        dispatch(getFleetItemVendorDetailsSave(payload))
      } else {
        dispatch(getFleetItemVendorDetailsSave(payload))
      }
  }



  // Shared helper — shows the VIN duplicate confirmation popup.
  // onConfirm is called when user clicks OK to proceed with save.
  const showVinDuplicatePopup = (message: string, onConfirm: () => void) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: '',
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: <p>{message}</p>,
      primaryBtnText: 'OK',
      outlineBtnText: 'Cancel',
      isSingleConfirmationBtn: false,
      popupOutlinebtnOnclick: () => setPopupcontent((prev: any) => ({ ...prev, isDialogVisible: false })),
      popupPrimarybtnOnclick: () => {
        setPopupcontent((prev: any) => ({ ...prev, isDialogVisible: false }));
        onConfirm();
      },
      hideDialog: () => setPopupcontent((prev: any) => ({ ...prev, isDialogVisible: false })),
    });
  };

  const savePurchaseOrderData = (poNumber?: any) => {
    if (errors?.poDescription1 || errors?.poDescription2) {
      return;
    }

      const payload = {
        fleetDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
        ponumber: poNumber || purchaseOrderStepperData?.poNumber,
        make: purchaseOrderStepperData?.make,
        model: purchaseOrderStepperData?.model,
        eqClassCode: purchaseOrderStepperData?.eqClassCode,
        eqClassDescription: purchaseOrderStepperData?.eqClassDescription,
        glaccountNumber: purchaseOrderStepperData?.glaccountNumber,
        poDescription1: purchaseOrderStepperData?.poDescription1,
        poDescription2: purchaseOrderStepperData?.poDescription2,
        poReceiptDate: purchaseOrderStepperData?.poReceiptDate,
        poCreationDate: purchaseOrderStepperData?.poCreationDate,
        barcodeNo: purchaseOrderStepperData?.barcodeNo,
        savedBy: userDetails?.emailId,
        consolidatedFleetIds: null
      } 
      
      if(purchaseOrderStepperData?.createUniquePO && isNonstandardConsolidatedChecked === itemDetails?.orderRequestType){
        const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
        let consolidatedPo: any = []
        saveConsolidatedPoDataArr?.map((item: any) => {
          if (purchaseOrderStepperData?.orderRequestType === item?.orderRequestType 
            && item?.fleetRequestDetailId !== purchaseOrderStepperData?.fleetRequestDetailId
            && !item.poNumber 
            && !item.pocipDetails 
            && item?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED
            ) {
            consolidatedPo.push(item?.fleetRequestDetailId)
          }
        })
        payload.consolidatedFleetIds = consolidatedPo
        dispatch(getFleetItemPurchaseOrderSave(payload))
      } else {
        dispatch(getFleetItemPurchaseOrderSave(payload))
      }
  }

  const savePurchaseDetails = () => {
    let payload = commonSavePaload(false)

    // Within-order VIN duplicate check — show confirmation popup, user can still proceed
    if (purchaseOrderStepperData?.vinSerial?.trim()) {
      const trimmedVin = purchaseOrderStepperData.vinSerial.trim().toLowerCase();
      const duplicateItem = purchaseOrderStepperDataArr?.find(
        (item: any) =>
          item.fleetRequestDetailId !== purchaseOrderStepperData?.fleetRequestDetailId &&
          item?.vinSerial?.trim()?.toLowerCase() === trimmedVin
      );
      if (duplicateItem) {
        // Store payload with forceVinSave so OK handler dispatches directly — same pattern as backend VIN popup
        lastDispatchedPayload.current = { ...payload, forceVinSave: true };
        showVinDuplicatePopup(
          'The VIN/Serial you have entered is already associated with another item in this order. Do you still want to save?',
          () => dispatch(getFleetItemPurchaseDetailsSave(lastDispatchedPayload.current))
        );
        return;
      }
    }

      if (purchaseOrderStepperData?.createUniquePO) {
        const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
        let consolidatedPo: any = []
        saveConsolidatedPoDataArr?.map((item: any) => {
          if (purchaseOrderStepperData?.orderRequestType === item?.orderRequestType) {
            let linkedAttachmentTemp = linkedAttachment?.filter((item: any) => item?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId)
            let assetValue = (item?.assetNumber == "" || item?.assetNumber == null) ? null : item?.assetNumber
            consolidatedPo.push({
              ...item, loading: undefined,
              savedBy: userDetails?.emailId, assetNumber: assetValue, orderAttachments: attachmentsList,
              attachments: linkedAttachmentTemp[0]?.attachments,
              estDeliveryDate: item?.estDeliveryDate ?? moment().add(15, 'd').toDate(),
            })
          }
        })
        let isDuplicate = false

        consolidatedPo?.map((item: any) => {
          if (item?.validationMessage)
            isDuplicate = true
        })

        if (isDuplicate) {
          return;
        }

        let consolidatedAssets: any = []
        let validatedAssets: any = []
        consolidatedPo?.map((item: any) => {
          if (item.assetNumber)
            consolidatedAssets.push(Number(item.assetNumber))
        })

        purchaseOrderStepperDataArr?.map((item: any) => { 
          if (item.assetNo)
            validatedAssets.push(Number(item.assetNo))
        })

        consolidatedAssets = consolidatedAssets.filter((item: any) => {
          return !validatedAssets.includes(item);
        });
        if (consolidatedAssets?.length === 0) {
          const consolidatedPoTemp = consolidatedPo?.filter((item: any) => item.fleetRequestDetailId !== purchaseOrderStepperData?.fleetRequestDetailId && !item.poNumber && !item.pocipDetails)?.map((item: any) => item?.fleetRequestDetailId)
          payload.consolidatedFleetIds = consolidatedPoTemp
          dispatch(setFleetItemId(purchaseOrderStepperData?.itemId))
          // Validate critical fields before saving
          if (!validateNullFields(payload)) {
            showValidationWarning();
            return;
          }
          // If VIN hasn't changed from the last saved value, skip the duplicate check
          if (payload.vinSerial && payload.vinSerial === originalVinSerialRef.current) {
            payload = { ...payload, forceVinSave: true };
          }
          lastDispatchedPayload.current = payload;
          dispatch(getFleetItemPurchaseDetailsSave(payload))
        }
        else {
          dispatch(setFleetItemId(purchaseOrderStepperData?.itemId))
          dispatchGetFleetAssetValidation([purchaseOrderStepperData.assetNumber])
        }
      } else if (!purchaseOrderStepperData?.assetNumber || purchaseOrderStepperData?.pocipDetails) {
        // Validate critical fields before saving
        if (!validateNullFields(payload)) {
          showValidationWarning();
          return;
        }
        // If VIN hasn't changed from the last saved value, skip the duplicate check
        if (payload.vinSerial && payload.vinSerial === originalVinSerialRef.current) {
          payload = { ...payload, forceVinSave: true };
        }
        lastDispatchedPayload.current = payload;
        dispatch(getFleetItemPurchaseDetailsSave(payload))
      } else if (activeStepper == 1 && purchaseOrderStepperData?.assetNumber && !purchaseOrderStepperData?.createUniquePO) {
        let isDuplicate = false
        purchaseOrderStepperDataArr?.map((item: any) => {
          if (item?.itemId != purchaseOrderStepperData?.itemId) {
            if (item?.assetNumber && purchaseOrderStepperData?.assetNumber && item?.assetNumber == purchaseOrderStepperData?.assetNumber) {
              setErrors({
                assetNumber: true,
                assetValidationText: "The Asset # you have entered is already associated with other item. Please enter a new asset number that is not been associated."
              });
              isDuplicate = true
            }
          }
        })
        if (isDuplicate) {
          return;
        }
        // Within-order VIN duplicate check for this branch — same as above
        if (purchaseOrderStepperData?.vinSerial?.trim()) {
          const trimmedVin = purchaseOrderStepperData.vinSerial.trim().toLowerCase();
          const duplicateVinItem = purchaseOrderStepperDataArr?.find(
            (item: any) =>
              item.fleetRequestDetailId !== purchaseOrderStepperData?.fleetRequestDetailId &&
              item?.vinSerial?.trim()?.toLowerCase() === trimmedVin
          );
          if (duplicateVinItem) {
            lastDispatchedPayload.current = { ...payload, forceVinSave: true };
            showVinDuplicatePopup(
              'The VIN/Serial you have entered is already associated with another item in this order. Do you still want to save?',
              () => dispatch(getFleetItemPurchaseDetailsSave(lastDispatchedPayload.current))
            );
            return;
          }
        }
        if (purchaseOrderStepperData?.assetNo != purchaseOrderStepperData?.assetNumber && !purchaseOrderStepperData?.pocipDetails) {
          if (!isNaN(purchaseOrderStepperData?.assetNumber)) {
            dispatchGetFleetAssetValidation([purchaseOrderStepperData?.assetNumber])
            dispatch(setFleetItemId(purchaseOrderStepperData?.itemId))
          }
          else {
            dispatchSetError({
              showAlert: true,
              type: "warning",
              text: "Please enter the valid asset before saving.",
              itemNumber: +String(itemDetails?.itemId).split("-")[1],
            });

            setTimeout(() => {
              dispatchSetError(undefined);
            }, 5000);
          }
        } else {
          // Validate critical fields before saving
          if (!validateNullFields(payload)) {
            showValidationWarning();
            return;
          }
          // If VIN hasn't changed from the last saved value, skip the duplicate check
          if (payload.vinSerial && payload.vinSerial === originalVinSerialRef.current) {
            payload = { ...payload, forceVinSave: true };
          }
          lastDispatchedPayload.current = payload;
          dispatch(getFleetItemPurchaseDetailsSave(payload))
        }
      }
  }

  const handleClickReturnToRequestor = (e?: any, id?: any) =>{
    e.preventDefault();
    e.stopPropagation()
    let decriptionTxt = (
      <>
        <p>Please provide a comment before returning order request to the requestor</p>
      </>
    );
    setReturnPopupcontent({
      ...returnPopupcontent,
      titleImg: CommentBee,
      title: "RETURN ORDER TO REQUESTOR",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      primaryBtnText: "Return",
      outlineBtnText: "Cancel",
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isSingleConfirmationBtn: false,
      popupOutlinebtnOnclick: () => {
        setReturnPopupcontent({ ...returnPopupcontent, isDialogVisible: false })
      },
      popupPrimarybtnOnclick: (item: any,
        comment: string,
        actionby: string,
        value: any) => {
          let consolidatedPo: any = []
          if(purchaseOrderStepperData?.createUniquePO){
            const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
            saveConsolidatedPoDataArr?.map((item: any) => {
              if (purchaseOrderStepperData?.orderRequestType === item?.orderRequestType && item?.fleetRequestDetailId !== purchaseOrderStepperData?.fleetRequestDetailId && !item.poNumber && !item.pocipDetails && item?.itemStatus !== CONSTANTS.ORDER_STATUS.CANCELLED && !item.alreadyReturnedFromFleet) {
                consolidatedPo.push(item?.fleetRequestDetailId)
              }
            })
          }
        let val = {
          orderId : purchaseOrderStepperData?.orderRequestId,
          fleetDetailId: parseInt(id),
          savedBy: userDetails?.emailId,
          comments: comment,
          consolidatedFleetIds : consolidatedPo
        }
        dispatch(getFleetItemReturnToRequestor(val))
        setReturnPopupcontent({ ...returnPopupcontent, isDialogVisible: false })
      }
    });
  }

  const handleClickCancel = () => {
    let decriptionTxt = (
      <>
        <p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>
      </>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "UNSAVED CHANGES",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
    });
  };

  const hideDialog = useCallback(
  () => {
    if (Popupcontent.hideDialog) {  
      Popupcontent.hideDialog();    
    } else {
      setPopupcontent({ ...Popupcontent, isDialogVisible: false });  
    }
  },
  [Popupcontent]
);

  const dismissAlert = () => dispatchSetError(undefined);

const popupOutlinebtnOnclick = () => {
  if (Popupcontent.popupOutlinebtnOnclick) {  
    Popupcontent.popupOutlinebtnOnclick();     
  } else {
    hideDialog();  // ← Default
    setIsRefreshError(false)
  }
};

  const popupPrimarybtnOnclick = (item: any) => {
    dispatchNav(item);
    navigate("/ordermanagement")
    hideDialog();
  };

  const dealerDetails = [
  CONSTANTS.DEALER_DETAILS.DEALER_NAME,
  CONSTANTS.DEALER_DETAILS.DEALER_EMAIL,
  CONSTANTS.DEALER_DETAILS.DEALER_ADD1,
  CONSTANTS.DEALER_DETAILS.DEALER_ADD2,
  CONSTANTS.DEALER_DETAILS.DEALER_ADD3,
  CONSTANTS.DEALER_DETAILS.DEALER_CITY,
  CONSTANTS.DEALER_DETAILS.DEALER_STATE,
  CONSTANTS.DEALER_DETAILS.DEALER_ZIP,
  CONSTANTS.DEALER_DETAILS.DEALER_PHONE
];

const dealerDateGLFields = [
  CONSTANTS.DEALER_DETAILS.ACTUAL_DELIVERY_DATE,
  CONSTANTS.DEALER_DETAILS.EST_DELIVERY_DATE,
  CONSTANTS.DEALER_DETAILS.GL_ACCOUNT_NUMBER,
  "comment"
];

const vendorFields = [
  "vendorEmailAddress", "vendorAbNumber", "vendorName", "vendorAdd1",
  "vendorAdd2", "vendorState", "vendorCity", "vendorZip"
];

const isChangedAfterPo = (stepper: any, name: string) => {
  return (
    (stepper?.poNumber || check) &&
    !stepper?.createUniquePO &&
    name === "assetNumber" &&
    stepper?.isCipPoolSaved
  );
};

const updateValue = (name: string, value: any, items?: any, dirtyStep?: string) => {
    let purchaseOrderData = {
      ...purchaseOrderStepperData,
      assetIsValid:"",
      validationMessage:"",
    };

    if (activeStepper === 2 && !skipVendorDetail) {
      if (dealerDateGLFields.includes(name)) {
        purchaseOrderData = {
          ...purchaseOrderData,
          [name]: value,
        };
      } else {
        if (dealerDetails.includes(name)) {
          purchaseOrderData = {
            ...purchaseOrderData,
            isDealerVendorSave : false,
            poDealerDetails: {
              ...purchaseOrderData.poDealerDetails,
              [name]: name === CONSTANTS?.DEALER_DETAILS.DEALER_PHONE ? items: value,
            },
          };
        } else if(vendorFields.includes(name)){
          purchaseOrderData = {
            ...purchaseOrderData,
            isDealerVendorSave : false,
            poVendorDetails: {
              ...purchaseOrderData.poVendorDetails,
              [name]: value,
            },
          };
        } else {
          if(name == "assetNumber"){
            purchaseOrderData = {
              ...purchaseOrderData,
              poVendorDetails: {
                ...purchaseOrderData.poVendorDetails,
                [name]: value,
                isChangedAfterPoCreation: isChangedAfterPo(purchaseOrderStepperData, name) ? true : false
              },
            };
          }else{
            purchaseOrderData = {
              ...purchaseOrderData,
              poVendorDetails: {
                ...purchaseOrderData.poVendorDetails,
                [name]: value,
              },
            };
          }
        }
      }
    } else {
      if (name === CONSTANTS.DEALER_DETAILS.PRICE_PER_UNIT) {
        purchaseOrderData = {
          ...purchaseOrderData,
          [dirtyStep ?? 'no-name']: false,
          [name]: value,
          poPricePerUnit: value,
          popricePerUnit: value
        };
      } else {
        if(value == purchaseOrderData?.assetNo && purchaseOrderData?.poNumber && name == "assetNumber"){
          purchaseOrderData = {
            ...purchaseOrderData,
            [name]: value,
            [dirtyStep ?? 'no-name']: true,
            isChangedAfterPoCreation: isChangedAfterPo(purchaseOrderStepperData, name) ? true : false
          };
        }else if(name == "assetNumber"){
          purchaseOrderData = {
            ...purchaseOrderData,
            [name]: value,
            [dirtyStep ?? 'no-name']: false,
            isChangedAfterPoCreation: isChangedAfterPo(purchaseOrderStepperData, name) ? true : false
          };
        }else if(name == "vinSerial"){
          dispatch(setVinValidationResult(null));
          const hasCip = purchaseOrderData?.pocipDetails?.hasOwnProperty('cipUnitNumber');
          const cipSerial = purchaseOrderData?.pocipDetails?.cipSerialNumber?.trim() || '';
          purchaseOrderData = {
            ...purchaseOrderData,
            [name]: value,
            isVinUpdated: !!value,
            vinSerialSource: value ? "LEADR" : purchaseOrderData?.vinSerialSource,
            vinValidationMessage: '',
            vinSerialMismatch: hasCip ? (value?.trim() || '') !== cipSerial : false,
            [dirtyStep ?? 'no-name']: false
          };
        }else{
          purchaseOrderData = {
            ...purchaseOrderData,
            [name]: value,
            [dirtyStep ?? 'no-name']: false
          };
        }
        
      }
    }

    setErrors((prev: any) => ({ ...prev, [name]: !value }));
    validateLength(name, value);
    dispatchStepperData(purchaseOrderData);
    const tempPurchaseStepperArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr))?.map((item: any) => {
      if(item?.fleetRequestDetailId === purchaseOrderData?.fleetRequestDetailId){
        return {
          ...purchaseOrderData,
          [dirtyStep ?? 'no-name'] : (value == purchaseOrderData?.assetNo && purchaseOrderData?.poNumber && name == "assetNumber") ? true :false
        }
      }
      return item
    })

    dispatchStepperDataArr(tempPurchaseStepperArr)
  };

  const validateLength = (fieldName: string, fieldValue: any) => {
    const commonLengthRequired = [CONSTANTS.DEALER_DETAILS.DEALER_NAME, CONSTANTS.DEALER_DETAILS.DEALER_ADD1,CONSTANTS.VENDOR_DETAILS.VENDOR_NAME,CONSTANTS.VENDOR_DETAILS.VENDOR_ADD1,CONSTANTS.VENDOR_DETAILS.VENDOR_CITY]
    const commonLength = [CONSTANTS.DEALER_DETAILS.DEALER_ADD2, CONSTANTS.DEALER_DETAILS.DEALER_ADD3,CONSTANTS.VENDOR_DETAILS.VENDOR_ADD2]
    // if(fieldName === CONSTANTS.DEALER_DETAILS.GL_ACCOUNT_NUMBER){
    //   fieldValue?.length > 10 && setErrors((prev) => ({ ...prev, [fieldName]: true }));
    // }else 
    if (fieldName === CONSTANTS.DEALER_DETAILS.PRICE_PER_UNIT) {
      (fieldValue?.length > 15 || parseInt(fieldValue) <= 0) && setErrors((prev: any) => ({ ...prev, [fieldName]: true }));
    } else if (fieldName === CONSTANTS.DEALER_DETAILS.DEALER_STATE || fieldName === CONSTANTS.VENDOR_DETAILS.VENDOR_STATE) {
      fieldValue?.length > 2 && setErrors((prev: any) => ({ ...prev, [fieldName]: true }));
    } else if (fieldName === CONSTANTS.DEALER_DETAILS.DEALER_ZIP || fieldName === CONSTANTS.VENDOR_DETAILS.VENDOR_ZIP) {
      fieldValue?.length > 12 && setErrors((prev: any) => ({ ...prev, [fieldName]: true }));
    } else if (fieldName === CONSTANTS.DEALER_DETAILS.DEALER_EMAIL || (fieldName === CONSTANTS.VENDOR_DETAILS.VENDOR_EMAIL && fieldValue?.length > 0)) {
      (fieldValue?.length > 100 || isEmail(fieldValue)) && setErrors((prev: any) => ({ ...prev, [fieldName]: true }));
    } else if (commonLengthRequired.includes(fieldName)) {
      fieldValue?.length > 50 && setErrors((prev: any) => ({ ...prev, [fieldName]: true }));
    } else if (commonLength.includes(fieldName)) {
      if (fieldValue?.length > 50)
        setErrors((prev: any) => ({ ...prev, [fieldName]: true }));
      else
        setErrors((prev: any) => ({ ...prev, [fieldName]: false }));
    } else if(fieldName === 'comment'){
      if(fieldValue?.length > 500){
        setErrors((prev: any) => ({ ...prev, [fieldName]: true }))
      }else {
        setErrors((prev: any) => ({ ...prev, [fieldName]: false }))
      }
    } else if(fieldName === 'vinSerial'){
      if(fieldValue?.length > 30){
        setErrors((prev: any) => ({ ...prev, [fieldName]: "Please enter vin/Serial Number less than 30 character" }))
      }else {
        setErrors((prev: any) => ({ ...prev, [fieldName]: "" }))
      }
    }
  }
  const restoreAssetData = (value: string) => {
    const purchaseOrderData = {
      ...purchaseOrderStepperData,
      assetNumber: value,
      pocipDetails: undefined,
      assetSourcing: "Stock",
      poDealerDetails: undefined,
      validationMessage: "",
      isPurchaseDetailsSave: false,
      isChangedAfterPoCreation: ((purchaseOrderStepperData?.poNumber || check) && !purchaseOrderStepperData?.createUniquePO && purchaseOrderStepperData?.isCipPoolSaved) ? true : false,
      description: (purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.NON_STANDARD_EQUIPMENT && purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.MANAGED_EQUIPMENT) ? "" : purchaseOrderStepperData?.description,
      descriptionId: (purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.NON_STANDARD_EQUIPMENT && purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.MANAGED_EQUIPMENT) ? "" : purchaseOrderStepperData?.descriptionId,
      pricePerUnit: (purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.NON_STANDARD_EQUIPMENT && purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.MANAGED_EQUIPMENT) ? "0.00" : purchaseOrderStepperData?.pricePerUnit,
      assetModelId: (purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.NON_STANDARD_EQUIPMENT && purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.MANAGED_EQUIPMENT) ? null : purchaseOrderStepperData?.assetModelId
    };
    setErrors({ assetNumber: false });

    dispatchStepperData(purchaseOrderData);
    setSkipVendorDetail(false);
  };

  const getStepperName = (name: string) => {
    if(['poReceiptDate', 'poDescription1', 'poDescription2', 'make', 'model', 'barcodeNo'].includes(name)){
      return 'isPurchaseOrderSave'
    } else if (['assetNumber', 'pricePerUnit', 'isLicensedTitled', 'purchaseType', 'orderTypeId', 'descriptionId', 'vinSerial'].includes(name)){
      return 'isPurchaseDetailsSave'
    }
  }

  const updateConsolidatedItems = (consolidatedItemArr: any, name: string, value: string, orderType: string, defaultGLType: any) => {
    const ConsolidatedPoData = consolidatedItemArr?.map((item: any) => {
       if (item?.orderRequestType === orderType && !item?.pocipDetails && !item.poNumber && item?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED) {
         const purchaseOrderData = {
           ...item,
           [name]: value,
           glaccountNumber: defaultGLType.includes(value) ? CONSTANTS.PURCHASE_TYPES.DEFAULT_GL_ACCOUNT_NUMBER : "",
           isPurchaseDetailsSave: item.fleetRequestDetailId == purchaseOrderStepperData?.fleetRequestDetailId ? false : item?.isPurchaseDetailsSave,
         };
         return purchaseOrderData
       }
       return item
     })
     dispatchStepperDataArr(ConsolidatedPoData)
   }
   const updatePurchaseType = (name: string, value: any) => {
     const types = [CONSTANTS.PURCHASE_TYPES.CAPITAL_LEASE, CONSTANTS.PURCHASE_TYPES.OPERATING_LEASE]
     let saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
     if (isVehicleConsolidatedChecked === itemDetails?.orderRequestType) {
       updateConsolidatedItems(saveConsolidatedPoDataArr, name, value, CONSTANTS.VEHICLE_REQUEST, types)
     } else if (isManageEquipConsolidatedChecked === itemDetails?.orderRequestType) {
       updateConsolidatedItems(saveConsolidatedPoDataArr, name, value, CONSTANTS.MANAGED_EQUIPMENT, types)
     } else if (isNonstandardConsolidatedChecked === itemDetails?.orderRequestType) {
       updateConsolidatedItems(saveConsolidatedPoDataArr, name, value, CONSTANTS.NON_STANDARD_EQUIPMENT, types)
     } else {
       const purchaseOrderData = {
         ...purchaseOrderStepperData,
         [name]: value,
         glaccountNumber: types.includes(value) ? CONSTANTS.PURCHASE_TYPES.DEFAULT_GL_ACCOUNT_NUMBER : "",
         isPurchaseDetailsSave: false
       };
       dispatchStepperData(purchaseOrderData);
     }
   }

  const onIsLicensedTitledChange = (name: string, value: any, meesage: string, dirtyFormName?: any) => {
    const popUpDecriptionTxt = (
        <>
            <p>On changing the {meesage} task list will get reset.</p>
            <p>Are you sure you want to continue?</p>
        </>
    );
    setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: CONSTANTS.TITLE_CONFIRMATION,
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: popUpDecriptionTxt,
        primaryBtnText: "Yes",
        outlineBtnText: "No",
        popupOutlinebtnOnclick: () => {
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
        },
        popupPrimarybtnOnclick: () => {
          if(name === 'isLicensedTitled'){
            updateValue(name, value, undefined, dirtyFormName);
          } else {
            updatePurchaseType(name, value)
          }
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
        },
        hideDialog: () => {
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
        },
        isSingleConfirmationBtn: false,
    });
}

  const handleChange = (event: any, items?: any, fleetId?: any) => {
    let value = event.target.value;
    const name = event.target.name;
    const dirtyFormName = getStepperName(name)
    let val = items;

    // Apply VIN/Serial formatting - alphanumeric only, no spaces, uppercase
    if (name === "vinSerial") {
      value = formatVinSerial(value);
    }
    
    // Sanitize E1 fields for all order types
    if (name === "poDescription1" || name === "poDescription2") {
      value = sanitizeE1Input(value);
    }

    if ((name === "assetNumber") && val) {
        const regEx = /^\d{0,9}(\.\d{1,4})?$/;
        const valArr = val.split('.')
        const checkNumber = regEx.test(val);
        if (!checkNumber || valArr.length > 1) {
            return;
        }
    }
    if (name === "assetNumber" && skipVendorDetail) {
      restoreAssetData(value);
      return;
    }
    const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
    let ConsolidatedPoData: any = []

    if (name == "dealerContactEmail" || name == "dealerAdd3" || name == "dealerAdd2" || name == "dealerAdd1" || name == "dealerName" || name == "dealerState" || name == "dealerCity" || name == "dealerZip" || name == "dealerPhone") {
      if (isVehicleConsolidatedChecked === itemDetails?.orderRequestType) {
        ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item: any) => {
          if (item?.orderRequestType === CONSTANTS.VEHICLE_REQUEST && !item?.pocipDetails && !item.poNumber && item?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED) {
            const purchaseOrderData = {
              ...item,
              isDealerVendorSave : item.fleetRequestDetailId == fleetId ? false : item?.isDealerVendorSave,
              poDealerDetails: {
                ...item?.poDealerDetails,
                [name]: name == "dealerPhone" ? items : value
              }
            };
            setErrors((prev: any) => ({ ...prev, [name]: !value }));
            return purchaseOrderData
          }
          return item
        })
        dispatchStepperDataArr(ConsolidatedPoData)
      }
      else if (isManageEquipConsolidatedChecked === itemDetails?.orderRequestType) {
        ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item: any) => {
          if (item?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT && !item?.pocipDetails && !item.poNumber && item?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED) {
            const purchaseOrderData = {
              ...item,
              isDealerVendorSave : item.fleetRequestDetailId == fleetId ? false : item?.isDealerVendorSave,
              poDealerDetails: {
                ...item?.poDealerDetails,
                [name]: name == "dealerPhone" ? items : value
              }
            };
            setErrors((prev: any) => ({ ...prev, [name]: !value }));
            return purchaseOrderData
          }
          return item
        })
        dispatchStepperDataArr(ConsolidatedPoData)
      }
      else if (isNonstandardConsolidatedChecked === itemDetails?.orderRequestType) {
        ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item: any) => {
          if (item?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT && !item?.pocipDetails && !item.poNumber && item?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED) {
            const purchaseOrderData = {
              ...item,
              isDealerVendorSave : item.fleetRequestDetailId == fleetId ? false : item?.isDealerVendorSave,
              poDealerDetails: {
                ...item?.poDealerDetails,
                [name]: name == "dealerPhone" ? items : value
              }
            };
            setErrors((prev: any) => ({ ...prev, [name]: !value }));
            return purchaseOrderData
          }
          return item
        })
        dispatchStepperDataArr(ConsolidatedPoData)
      } else {
        updateValue(name, value, items);
      }
      setErrors((prev: any) => ({ ...prev, [name]: !value }));
      validateLength(name, value);
    } else if (name == "vendorContactEmail" || name == "vendorAbNumber" || name == "vendorName" || name == "vendorAdd1" || name == "vendorAdd2" || name == "vendorState" || name == "vendorCity" || name == "vendorZip") {
      if (isVehicleConsolidatedChecked === itemDetails?.orderRequestType) {
        ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item: any) => {
          if (item?.orderRequestType === CONSTANTS.VEHICLE_REQUEST && !item?.pocipDetails && !item.poNumber && item?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED) {
            const purchaseOrderData = {
              ...item,
              isDealerVendorSave : item.fleetRequestDetailId == fleetId ? false : item?.isDealerVendorSave,
              poVendorDetails: {
                ...item?.poVendorDetails,
                [name]: value
              }
            };
            if(name == "vendorContactEmail" && value?.length == 0){
              setErrors((prev: any) => ({ ...prev, [name]: false }));
            }else{
              setErrors((prev: any) => ({ ...prev, [name]: !value }));
            }            
            return purchaseOrderData
          }
          return item
        })
        dispatchStepperDataArr(ConsolidatedPoData)
      } else if (isManageEquipConsolidatedChecked === itemDetails?.orderRequestType) {
        ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item: any) => {
          if (item?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT && !item?.pocipDetails && !item.poNumber && item?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED) {
            const purchaseOrderData = {
              ...item,
              isDealerVendorSave : item.fleetRequestDetailId == fleetId ? false : item?.isDealerVendorSave,
              poVendorDetails: {
                ...item?.poVendorDetails,
                [name]: value
              }
            };
            if(name == "vendorContactEmail" && value?.length == 0){
              setErrors((prev: any) => ({ ...prev, [name]: false }));
            }else{
            setErrors((prev: any) => ({ ...prev, [name]: !value }));
            }
            return purchaseOrderData
          }
          return item
        })
        dispatchStepperDataArr(ConsolidatedPoData)
      } else if (isNonstandardConsolidatedChecked === itemDetails?.orderRequestType) {
        ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item: any) => {
          if (item?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT && !item?.pocipDetails && !item.poNumber && item?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED) {
            const purchaseOrderData = {
              ...item,
              isDealerVendorSave : item.fleetRequestDetailId == fleetId ? false : item?.isDealerVendorSave,
              poVendorDetails: {
                ...item?.poVendorDetails,
                [name]: value
              }
            };
            if(name == "vendorContactEmail" && value?.length == 0){
              setErrors((prev: any) => ({ ...prev, [name]: false }));
            }else{
            setErrors((prev: any) => ({ ...prev, [name]: !value }));
            }
            return purchaseOrderData
          }
          return item
        })
        dispatchStepperDataArr(ConsolidatedPoData)
      } else {
        updateValue(name, value);
      }
      if(name == "vendorContactEmail" && value?.length == 0){
        setErrors((prev: any) => ({ ...prev, [name]: false }));
      }else{
      setErrors((prev: any) => ({ ...prev, [name]: !value }));
      }
      validateLength(name, value);
    } else if (name == "isLicensedTitled") {
        let message = "Asset to be Licensed or Titled"
        onIsLicensedTitledChange(name, items, message, dirtyFormName)
    } else if (name == "poDescription1" && isNonstandardConsolidatedChecked === itemDetails?.orderRequestType) {
      if (value.length > 30) {
        setErrors((prev: any) => ({ ...prev, [name]: 'length-30' }));
      }
      ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item: any) => {
        if (item?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT && !item?.pocipDetails && !item.poNumber && item?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED) {
          const purchaseOrderData = {
            ...item,
            isPurchaseOrderSave: item.fleetRequestDetailId == fleetId ? false : item?.isPurchaseOrderSave,
            [name]: value
          };
          setErrors((prev: any) => ({ ...prev, [name]: value.length > 30 ? 'length-30' : !value }));
          return purchaseOrderData
        }
        return item
      })
      dispatchStepperDataArr(ConsolidatedPoData)
    } else if (name == "poDescription1") {
      updateValue(name, value, undefined, dirtyFormName);
      if (value.length > 30) {
        setErrors((prev: any) => ({ ...prev, [name]: 'length-30' }));
      }
    } else if (name == "poDescription2") {
      updateValue(name, value, undefined, dirtyFormName);
      if (value.length > 30) {
        setErrors((prev: any) => ({ ...prev, [name]: 'length-30' }));
      }
    }
     else {
      updateValue(name, value, undefined, dirtyFormName);
    }
  };

  const handleChangeDropDown = (event: any, item: any) => {
    const value = item.value;
    const name = event.target.getAttribute("name");

    if (name == "purchaseType") {
      let message = "Purchase Type"
      onIsLicensedTitledChange(name, value, message)
    }
    else {
      let purchaseOrderData = {
        ...purchaseOrderStepperData,
        [name]: value,
      };
      if (name == "reasonCodeId") {
        purchaseOrderData = { ...purchaseOrderStepperData, reasonCode: item.text, reasonCodeId: item.value };
      }
      else if (name == "orderTypeId") {
        purchaseOrderData = { ...purchaseOrderStepperData, orderType: item.text, orderTypeId: item.value, isPurchaseDetailsSave: false };
      }
      dispatchStepperData(purchaseOrderData);
      if (name == "assignedTo") {
        let linkedAttachmentTemp = linkedAttachment?.filter((item: any) => item?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId)
        let saveValue = {
          poFleetDetailId: parseInt(purchaseOrderStepperData?.fleetRequestDetailId),
          savedBy: userDetails?.emailId,
          poFleetRequestTaskListTrackings: [],
          assignedTo: value,
          orderRequestId: parseInt(purchaseOrderStepperData?.orderRequestId),
          orderAttachments: attachmentsList,
          itemAttachments: linkedAttachmentTemp[0]?.attachments,
          estDeliveryDate: purchaseOrderStepperData?.estDeliveryDate ? moment(purchaseOrderStepperData?.estDeliveryDate).format("YYYY-MM-DD") : moment().add(15, 'd').toDate(),
          actualDeliveryDate: purchaseOrderStepperData?.actualDeliveryDate ? moment(purchaseOrderStepperData?.actualDeliveryDate).format("YYYY-MM-DD") : null
        }
        dispatch(getSaveAdminTaskvalue(saveValue))
        if (value?.trim()?.length && value != "Unassigned") {
          setAssignedToError("")
        }
      }
    }
  };

  const isCompleted = useMemo(
    () => itemDetails?.fleetStatus === "Requisition Complete",
    [itemDetails]
  );

  const purchaseVendorDetails = (item: any, data: any) => {
    return {
      ...item,
      purchaseType: data?.purchaseType,
      poDealerDetails: {
        ...(item.poDealerDetails || {}),
        dealerContactEmail: data?.poDealerDetails?.dealerContactEmail,
        dealerAbNumber: data?.poDealerDetails?.dealerAbNumber,
        dealerName: data?.poDealerDetails?.dealerName,
        dealerAdd1: data?.poDealerDetails?.dealerAdd1,
        dealerAdd2: data?.poDealerDetails?.dealerAdd2,
        dealerAdd3: data?.poDealerDetails?.dealerAdd3,
        dealerState: data?.poDealerDetails?.dealerState,
        dealerZip: data?.poDealerDetails?.dealerZip,
        dealerPhone: data?.poDealerDetails?.dealerPhone,
        vendorABNumber: data?.poDealerDetails?.vendorABNumber
      },
    };
  }

  useEffect(() => {
    const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
    let ConsolidatedPoData: any = []

    if (isVehicleConsolidatedChecked == CONSTANTS.VEHICLE_REQUEST) {
      let purchaseData: any = [];

      saveConsolidatedPoDataArr?.map((item: any) => {
        if (item?.orderRequestType === CONSTANTS.VEHICLE_REQUEST && !item?.pocipDetails && !item?.poNumber) {
          purchaseData.push(item)
        }
      })
      ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item: any) => {
        if (item?.orderRequestType === CONSTANTS.VEHICLE_REQUEST && !item?.pocipDetails && !item?.poNumber) {
          const value = purchaseVendorDetails(item, purchaseData[0])
          return { ...value }//item, purchaseType: purchaseData[0]?.purchaseType}
        }
        return item
      })
      dispatchStepperDataArr(ConsolidatedPoData)
    }
  }, [isVehicleConsolidatedChecked])

  useEffect(() => {
    const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
    let ConsolidatedPoData: any = []

    if (isManageEquipConsolidatedChecked == CONSTANTS.MANAGED_EQUIPMENT) {
      let purchaseData: any = [];

      saveConsolidatedPoDataArr?.map((item: any) => {
        if (item?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT && !item?.pocipDetails && !item?.poNumber) {
          purchaseData.push(item)
        }
      })
      ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item: any) => {
        if (item?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT && !item?.pocipDetails && !item?.poNumber) {
          const value = purchaseVendorDetails(item, purchaseData[0])
          return { ...value }
        }
        return item
      })
      dispatchStepperDataArr(ConsolidatedPoData)
    }
  }, [isManageEquipConsolidatedChecked])


  useEffect(() => {
    const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
    let ConsolidatedPoData: any = []

    if (isNonstandardConsolidatedChecked == CONSTANTS.NON_STANDARD_EQUIPMENT) {
      let purchaseData: any = [];

      saveConsolidatedPoDataArr?.map((item: any) => {
        if (item?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT && !item?.pocipDetails && !item?.poNumber) {
          purchaseData.push(item)
        }
      })
      ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item: any) => {
        purchaseData.push(item)
        if (item?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT && !item?.pocipDetails && !item?.poNumber) {
          const value = purchaseVendorDetails(item, purchaseData[0])
          return { ...value }
        }
        return item
      })
      dispatchStepperDataArr(ConsolidatedPoData)
    }
  }, [isNonstandardConsolidatedChecked])

  useEffect(() => {

    if (isVehicleConsolidatedChecked == CONSTANTS.VEHICLE_REQUEST) {

      if (isVehicleConsolidatedChecked == itemDetails?.orderRequestType && itemDetails?.pocipDetails?.cippoNumber != purchaseOrderStepperData?.pocipDetails?.cippoNumber) {
        setSkipVendorDetail(false)
        dispatchStepperData({ ...purchaseOrderStepperData, pocipDetails: null, assetNumber: null, assetSourcing: itemDetails?.assetSourcing })
      }
    }
    if (isManageEquipConsolidatedChecked == CONSTANTS.MANAGED_EQUIPMENT) {

      if (isManageEquipConsolidatedChecked == itemDetails?.orderRequestType && itemDetails?.pocipDetails?.cippoNumber != purchaseOrderStepperData?.pocipDetails?.cippoNumber) {
        setSkipVendorDetail(false)
        dispatchStepperData({ ...purchaseOrderStepperData, pocipDetails: null, assetNumber: null, assetSourcing: itemDetails?.assetSourcing })
      }
    }
    if (isNonstandardConsolidatedChecked == CONSTANTS.NON_STANDARD_EQUIPMENT) {

      if (isNonstandardConsolidatedChecked == itemDetails?.orderRequestType && itemDetails?.pocipDetails?.cippoNumber != purchaseOrderStepperData?.pocipDetails?.cippoNumber) {
        setSkipVendorDetail(false)
        dispatchStepperData({ ...purchaseOrderStepperData, pocipDetails: null, assetNumber: null, assetSourcing: itemDetails?.assetSourcing })
      }
    }


  }, [isVehicleConsolidatedChecked, isManageEquipConsolidatedChecked, isNonstandardConsolidatedChecked])

  const check = useMemo(() => {
    if (purchaseOrderStepperData?.poFleetRequestTaskListTrackings?.length && (purchaseOrderStepperData?.poNumber || (purchaseOrderStepperData?.pocipDetails != null && purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cippoNumber')))) {
      let istaskstarted = purchaseOrderStepperData?.poFleetRequestTaskListTrackings?.filter((filterItem?: any) => ((filterItem?.taskStatus == CONSTANTS.ORDER_STATUS.COMPLETED || filterItem?.taskStatus == CONSTANTS.ORDER_STATUS.NBYA) && filterItem?.taskDescription !== CONSTANTS.ORDER_STATUS.ASSIGNASSET))
      return istaskstarted?.length >= 1 ? true : false
    }
  }, [purchaseOrderStepperData?.poNumber,purchaseOrderStepperData?.pocipDetails, purchaseOrderStepperData?.poFleetRequestTaskListTrackings]);

  const onCloseLinkAttachment = (e: any) => {
    setIsAttachmentBtnClicked([])
    e.preventDefault();
    e.stopPropagation();
  }
  const onChangeLinkAttachment = (event: any, attachment: any, reason: any) => {
    event.preventDefault();
    let obj: any = {}
    let linkedVal = linkedAttachment;
    if (activeStepper == 4 || (activeStepper == 2 && skipVendorDetail)) {
      setAttachmentChangeFleetId(purchaseOrderStepperData?.fleetRequestDetailId)
    }
    if (event?.target?.checked) {
      let alreadyExist = linkedVal?.filter((item: any) => item?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId)
      if (linkedVal?.length && alreadyExist?.length) {
        for (let i = 0; i < linkedVal?.length; i++) {
          if (linkedVal[i]?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId) {
            linkedVal[i]?.attachments.push(attachment)
            obj.fleetItemId = purchaseOrderStepperData?.fleetRequestDetailId
            obj.attachments = linkedVal[i]?.attachments
            let remainingattach = linkedVal?.filter((item: any) => item?.fleetItemId != purchaseOrderStepperData?.fleetRequestDetailId)
            remainingattach.push(obj)
            dispatch(setLinkedAttachments(remainingattach));
            const payload = {
              orderId: purchaseOrderStepperData?.orderRequestId,
              fleetDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
              attachments: linkedVal[i]?.attachments,
              savedBy: userDetails?.emailId,
              orderAttachments: attachmentsList
            }
            dispatch(saveItemAttachmentsLinked(payload))
          }
        }
      } else if (!alreadyExist?.length && linkedVal?.length) {
        obj.fleetItemId = purchaseOrderStepperData?.fleetRequestDetailId
        obj.attachments = [attachment]
        linkedVal?.push(obj)
        dispatch(setLinkedAttachments(linkedVal));
        const payload = {
          orderId: purchaseOrderStepperData?.orderRequestId,
          fleetDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
          attachments: [attachment],
          savedBy: userDetails?.emailId,
          orderAttachments: attachmentsList
        }
        dispatch(saveItemAttachmentsLinked(payload))
      } else {
        obj.fleetItemId = purchaseOrderStepperData?.fleetRequestDetailId
        obj.attachments = [attachment]
        dispatch(setLinkedAttachments([obj]));

        const payload = {
          orderId: purchaseOrderStepperData?.orderRequestId,
          fleetDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
          attachments: [attachment],
          savedBy: userDetails?.emailId,
          orderAttachments: attachmentsList
        }
        dispatch(saveItemAttachmentsLinked(payload))
      }
    } else {
      for (let j = 0; j < linkedVal?.length; j++) {
        if (linkedVal[j]?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId) {
          let removedObj: any = {}
          removedObj.fleetItemId = purchaseOrderStepperData?.fleetRequestDetailId
          removedObj.attachments = linkedVal[j]?.attachments?.filter((x: any) => x.fileName !== attachment.fileName)
          let removedattach = linkedVal?.filter((item: any) => item?.fleetItemId != purchaseOrderStepperData?.fleetRequestDetailId)
          removedattach?.push(removedObj)
          dispatch(setLinkedAttachments(removedattach));

          const payload = {
            orderId: purchaseOrderStepperData?.orderRequestId,
            fleetDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
            attachments: linkedVal[j]?.attachments?.filter((x: any) => x.fileName !== attachment.fileName),
            savedBy: userDetails?.emailId,
            orderAttachments: attachmentsList
          }
          dispatch(saveItemAttachmentsLinked(payload))
        }
      }

    }
  }
  const onClicktLinkAttachment = (e: any, index: any) => {
    const attachmentButton: any = isAttachmentBtnClicked;
    attachmentButton[index] = !attachmentButton[index];
    setIsAttachmentBtnClicked([...attachmentButton])
    e.preventDefault();
    e.stopPropagation();
  }

  const getLinkedAttachmentsCount = (linkedAttachment: any) => {
    const filteredArr = linkedAttachment?.find((x: any) => x?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId)
    return filteredArr ? filteredArr?.attachments?.length : purchaseOrderStepperData?.attachments?.length ? purchaseOrderStepperData?.attachments?.length : 0;

  }

  const onClickAttachment = (item: any) => {
    let win = window.open();
    if (win) {
      win.document.write(
        '<iframe width="100%" height="100%" src="' +
        item +
        '" frameborder="0" ></iframe>'
      );
    }
  };

  const [currentDetail,setCurrentDetail] = useState<any>([]);

  const saveReasonCode = (e: any, item: any) => {
    handleChangeDropDown(e, item)
    const payload = {
      fleetDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
      reasonCodeId: item.value,
      savedBy: userDetails?.emailId
    }
    setCurrentDetail(payload);
    dispatchUpdateReasonCode(payload)
    dispatch(setReasonCodeResponse(undefined));
  }

  useEffect(()=>{
    if(reasonCodeUpdateResponse && currentDetail?.fleetDetailId != undefined){
       dispatchChangeLogs(currentDetail?.fleetDetailId);
       dispatch(setReasonCodeResponse(undefined));
       setCurrentDetail([]);
    }
   },[reasonCodeUpdateResponse])

  const reasonCodeValue = useMemo(() => {
    return reasonCode?.find(
      (x: any) => x.text === (purchaseOrderStepperData?.reasonCode || "N/A")
    );
  }, [purchaseOrderStepperData?.reasonCode, reasonCode]);

  useEffect(()=> {
    if(error?.fleetDetailId){
     const timer = setTimeout(() => {
        dispatchSetError(undefined);
      }, 5000);
      return () => clearTimeout(timer)
    }
  }, [error?.fleetDetailId])

  let isRequisitionComplete = savedStatus?.filter((saveItem: any) => (saveItem?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId))?.[0]
  
  const assignedToValue = useMemo(() => {
    return assignTo?.find(
      (x: any) => x?.value?.toLowerCase() == purchaseOrderStepperData.assignedTo?.toLowerCase()
    );
  }, [purchaseOrderStepperData.assignedTo, assignTo]);

  const returnReasonCodeBlock = () => {
    let status = savedStatus?.find((savedItem?: any) => savedItem?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId)
    return <Row className="reason-code-block"> 
    <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-md-2 mb-3 px-0">
    <Label data-attribute="VehicleRequestDetail_Container_Default_Label">Reason Code</Label>
    <DropdownBox
      name="reasonCodeId"
      selectedKey={reasonCodeValue?.key}
      onChange={(e: any, item: any)=> saveReasonCode(e, item)}
      placeholder="Select"
      options={reasonCode}
      disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS) || status?.itemStatus === CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || purchaseOrderStepperData.itemStatus === CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE}
     data-attribute="VehicleRequestDetail_Container_reasonCodeId_Dropdown" />
    {error?.fleetDetailId === purchaseOrderStepperData?.fleetRequestDetailId &&
      <span className={`${error?.type === 'error' ? 'validMessage' : 'successMessage'}`}>{error?.text}</span>
    }
  </Col>
  <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-md-2 mb-3 px-0 offset-md-4">
      <div className={`assigned-to mb-0 ${isnonStandardequipment ? 'nonstandard-equip' : ''}`}>
        <Label required data-attribute="VehicleRequestDetail_Container_Default_Label_2">Assigned To</Label>
        <DropdownBox
          name="assignedTo"
          placeholder="Select"
          options={assignTo}
          onChange={handleChangeDropDown}
          className={assignedToError ? 'controlValidation' : ""}
          selectedKey={assignedToValue?.key}
          disabled = {purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS)}
         data-attribute="VehicleRequestDetail_Container_assignedTo_Dropdown" />
      </div>
  </Col>
  </Row>
  }

  const panelList = !skipVendorDetail
    ? [
      {
        component: (
          <>
          {returnReasonCodeBlock()}
          <PurchaseDetail
            setSkipVendorDetail={setSkipVendorDetail}
            Popupcontent={Popupcontent}
            handleClickCancel={handleClickCancel}
            popupOutlinebtnOnclick={popupOutlinebtnOnclick}
            popupPrimarybtnOnclick={popupPrimarybtnOnclick}
            onDismiss={hideDialog}
            handleChange={handleChange}
            handleChangeDropDown={handleChangeDropDown}
            purchaseOrderStepperData={purchaseOrderStepperData}
            updateValue={updateValue}
            errors={errors}
            skipVendorDetail={skipVendorDetail}
            savePurchaseOrder={savePurchaseDetails}
            setErrors={setErrors}
            itemDetails={itemDetails}
            isCompleted={isCompleted}
            handleBlurChange={handleBlurChange}
            vinValidationResult={vinValidationResult}
            check={check}
            setClickPoolBtn={setClickPoolBtn}
            isBulkOrderRequest={isBulkOrder}
            isRequisitionComplete={isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE}
            getUserRoles={getUserRoles}
            orderDetails={orderDetails}
            originalVinSerial={originalVinSerialRef.current}
            onCatalogOverrideSaved={onCatalogOverrideSaved}
          />
          </>
        ),
      },
      {
        component: (
          <>
          {returnReasonCodeBlock()}
          <VendorDetail
            Popupcontent={Popupcontent}
            handleClickCancel={handleClickCancel}
            popupOutlinebtnOnclick={popupOutlinebtnOnclick}
            popupPrimarybtnOnclick={popupPrimarybtnOnclick}
            onDismiss={hideDialog}
            handleChange={handleChange}
            purchaseOrderStepperData={purchaseOrderStepperData}
            updateValue={updateValue}
            savePurchaseOrder={saveDealerVendorDetails}
            errors={errors}
            setErrors={setErrors}
            isCompleted={isCompleted}
            itemDetails={itemDetails}
            isBulkOrder={isBulkOrder}
          />
          </>
        ),
      },
      {
        component: (
          <>
          {returnReasonCodeBlock()}
          <PurchaseOrderDetail
            Popupcontent={Popupcontent}
            handleClickCancel={handleClickCancel}
            popupOutlinebtnOnclick={popupOutlinebtnOnclick}
            popupPrimarybtnOnclick={popupPrimarybtnOnclick}
            onDismiss={hideDialog}
            handleChange={handleChange}
            purchaseOrderStepperData={purchaseOrderStepperData}
            updateValue={updateValue}
            savePurchaseOrder={savePurchaseOrderData}
            errors={errors}
            isCompleted={isCompleted}
            itemDetails={itemDetails}
            setErrors={setErrors}
            isValidToCreatePO={purchaseOrderDetailFieldsCheck}
          />
          </>
        ),
      },
      {
        component: (
          <>
          {returnReasonCodeBlock()}
          <AdminTask
            setAssignedToError={setAssignedToError}
            assignedToError={assignedToError}
            taskList={purchaseOrderStepperData?.poFleetRequestTaskListTrackings}
            itemId={purchaseOrderStepperData?.itemId}
            purchaseOrderStepperData={purchaseOrderStepperData}
            attachmentChangeFleetId={attachmentChangeFleetId}
            setAttachmentChangeFleetId={setAttachmentChangeFleetId}
            itemType={"Requisition"}
            isComplete={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE}
            key={purchaseOrderStepperData?.itemId}
          />
          </>
        ),
      },
    ]
    : [
      {
        component: (
          <>
          {returnReasonCodeBlock()}
          <PurchaseDetail
            setSkipVendorDetail={setSkipVendorDetail}
            Popupcontent={Popupcontent}
            handleClickCancel={handleClickCancel}
            popupOutlinebtnOnclick={popupOutlinebtnOnclick}
            popupPrimarybtnOnclick={popupPrimarybtnOnclick}
            onDismiss={hideDialog}
            handleChange={handleChange}
            handleChangeDropDown={handleChangeDropDown}
            purchaseOrderStepperData={purchaseOrderStepperData}
            updateValue={updateValue}
            errors={errors}
            savePurchaseOrder={savePurchaseDetails}
            setErrors={setErrors}
            itemDetails={itemDetails}
            isCompleted={isCompleted}
            handleBlurChange={handleBlurChange}
            vinValidationResult={vinValidationResult}
            check={check}
            setClickPoolBtn={setClickPoolBtn}
            isRequisitionComplete= {isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE}
            getUserRoles={getUserRoles}
            originalVinSerial={originalVinSerialRef.current}
            orderDetails={orderDetails}
            onCatalogOverrideSaved={onCatalogOverrideSaved}
          />
          </>
        ),
      },
      {
        component: (
          <>
          {returnReasonCodeBlock()}
          <AdminTask
            setAssignedToError={setAssignedToError}
            assignedToError={assignedToError}
            taskList={purchaseOrderStepperData?.poFleetRequestTaskListTrackings}
            itemId={purchaseOrderStepperData?.itemId}
            purchaseOrderStepperData={purchaseOrderStepperData}
            attachmentChangeFleetId={attachmentChangeFleetId}
            setAttachmentChangeFleetId={setAttachmentChangeFleetId}
            itemType={CONSTANTS.REQUISITION}
            isComplete={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE}
          />
          </>
        ),
      },
    ];

  const onChnageQuoteAttached = (e: any, value: boolean) => {
    dispatchStepperData({...purchaseOrderStepperData, hasQuoteAttached: value})
  }  

  const handleClickSaveNSE = () => {
    if (editAssetInfo?.makeError?.length > 0 || editAssetInfo?.modelError?.length > 0 || editAssetInfo?.pricePerUnitError?.length > 0 || editAssetInfo?.descriptionError?.length > 0) {
      return
    } else {
      setEnableEditNSE(false);
      const payload = {
        fleetRequestDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
        savedBy: userDetails?.emailId,
        make: editAssetInfo?.make,
        model: editAssetInfo?.model,
        year: editAssetInfo?.year.value,
        isUsed: editAssetInfo?.isUsed.value === 'Yes',
        hasQuoteAttached: purchaseOrderStepperData?.hasQuoteAttached,
        popricePerUnit: editAssetInfo?.pricePerUnit ? parseFloat(getOnlyNumbers(editAssetInfo?.pricePerUnit)) : 0,
        description: editAssetInfo?.description
      }
      dispatch(saveNSEItemDetails(payload))
      dispatchStepperData({...purchaseOrderStepperData, ...payload})
    }
  }

  const handleClickEditNSE = (itemDetails: any) => {
    setEnableEditNSE(true)
    setEditAssetInfo({
      make: itemDetails?.make,
      model: itemDetails?.model,
      year: { label: itemDetails?.year, value: itemDetails?.year },
      isUsed: itemDetails?.isUsed ? { value: 'Yes', label: 'Yes' } : { value: 'No', label: 'No' },
      pricePerUnit: formatPrice(itemDetails?.poPricePerUnit, 2),
      description: itemDetails?.description
    });
  }

  const yearDropdownList = getYearDropdownList();
  const usedDropdownList = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
  ]

  const onDescriptionChange = (item: any) => {
    const tempArray = { ...editAssetInfo, description: item.target.value }
    const error = Validation.ValidateDescription(tempArray, tempArray)
    setEditAssetInfo({ ...error })
  }

  const onChangeMake = (item: any) => {
    const tempArray = { ...editAssetInfo, make: item.target.value }
    const error = Validation.ValidateMake(tempArray, tempArray)
    setEditAssetInfo({ ...error })
  }

  const onChangeModel = (item: any) => {
    const tempArray = { ...editAssetInfo, model: item.target.value }
    const error = Validation.ValidateModel(tempArray, tempArray)
    setEditAssetInfo({ ...error })
  }

  const onChangeYear = (item: any) => {
    setEditAssetInfo({ ...editAssetInfo, year: item })
  }

  const onChangeUsed = (item: any) => {
    setEditAssetInfo({ ...editAssetInfo, isUsed: item })
  }

  const onChangePrice = (item: any) => {
    const tempArray = { ...editAssetInfo, pricePerUnit: item.target.value }
    const error = Validation.ValidatePricePerUnit(tempArray, tempArray)
    setEditAssetInfo({ ...error })
  }

  const unitPriceFormat = (item: any) => {
    setEditAssetInfo({ ...editAssetInfo, pricePerUnit: formatPrice(item, 2) })
  };

  const isUploaded = (name: string) =>
  uploadedList?.find((x: any) => (x.name || (x as any).fileName) === name);

// To upload attachments
const onUploadClick = (fileList: Array<File>) => {
  let listItem = {
    fileList: fileList,
    uploadedList: uploadedList,
  }
  commononUploadClick(listItem, setAttachmentError, isUploaded, dispatch, uploadBulkOrderAttachments, itemDetails?.fleetRequestDetailId, true);
};  

const onRemoveClick = (index: number) => {
  const newArr = uploadedList.slice();
  newArr.splice(index, 1);
  dispatch(removeBulkOrderAttachment(newArr, itemDetails?.fleetRequestDetailId))
  setAttachmentError("");
};

  const autoSaveComments = (e: any) => {
    if (e?.target?.value && !errors?.comment) {
        const payload = {
          fleetDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
          savedBy: userDetails?.emailId,
          comment: purchaseOrderStepperData?.comment
        }
        dispatch(saveComment(payload))
    }
  }

  const onClickReturnToHome = () => {   
      dispatchHeaderNav(CONSTANTS.ACTIVE_HEADER.HOME)
      dispatchNav(CONSTANTS.ACTIVE_HEADER.HOME)
      dispatch(setOrderById({}))
      navigate('/ordermanagement');
  }

  const onClickSendPoToVendor = (e: any, itemDetails?: any) => {
    e.preventDefault();
    setSendEmailerror(initialError)
    dispatch(getPoVendorEmail({ poNumber: itemDetails?.poNumber, fleetRequestDetailId: itemDetails?.fleetRequestDetailId }))
  }

  useEffect(() => {
    if (poVendorEmailDetails?.hasOwnProperty('toEmailAddress') && poVendorEmailDetails?.emailAttachments?.length > 0 && poVendorEmailDetails?.fleetRequestDetailId == purchaseOrderStepperData?.fleetRequestDetailId) {
      setShowEmailPopup(true)
    } else if(poVendorEmailDetails?.hasOwnProperty('toEmailAddress') && poVendorEmailDetails?.fleetRequestDetailId == purchaseOrderStepperData?.fleetRequestDetailId && poVendorEmailDetails?.emailAttachments?.length == 0 && !showEmailPopup){
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: 'Kindly try after few minutes.',
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
      });
    }
  }, [poVendorEmailDetails])

  const openLinkInNewTab = (link?: any) => {
    let win = window.open();
      if (win) {
        win.document.write(
          '<iframe width="100%" height="100%" src="' +
          link +
          '" frameborder="0" ></iframe>'
        );
      }
    }

  const onClickViewPurchaseOrder = (e?: any, itemDetails?: any) => {
    e?.preventDefault();
    if (itemDetails?.poPdfUrl) {
      openLinkInNewTab(itemDetails?.poPdfUrl)
    } else {
      dispatch(getPoPdfLinkByPONumber({poNumber: itemDetails?.poNumber, fleetRequestDetailId: itemDetails?.fleetRequestDetailId}))
    }
  }

  const hidePopup = () => {
    setShowEmailPopup(false)
    setEmailAttachmentError('')
    setSendEmailList([])
    setSendEmailAttachmentsList([])
    dispatch(setPoVendorEmail({}))
    dispatch(uploadEmailAttachments([]))
    setSendEmailerror(initialError)
  }

  const handleClickTriggerEmail = (e: any, itemDetailsTemp: any) => {
    let bodyEmailErrorTemp = ''
    let toEmailErrorTemp = ''
    let bodyHtmlTemp: any = ''
    let isValid = true
    if (poVendorEmailDetails?.emailBody?.trim()?.length == 0) {
      bodyEmailErrorTemp = 'Please enter Email Body'
      isValid = false
    } else {
      bodyHtmlTemp = { __html: poVendorEmailDetails?.emailBody }
    }
    if (poVendorEmailDetails?.toEmailAddress?.length == 0) {
      toEmailErrorTemp = 'Please Enter To Email Address'
      isValid = false
    }
    let isDuplicationOccured = false
    if (poVendorEmailDetails?.toEmailAddress?.length > 0 && poVendorEmailDetails?.bccEmailAddress?.length > 0) {
      poVendorEmailDetails?.toEmailAddress?.map((mailItem?: any) => {
        let duplicateMail = poVendorEmailDetails?.bccEmailAddress?.filter((bccItem?: any) => bccItem?.toLowerCase() == mailItem?.toLowerCase())
        if (duplicateMail?.length > 0) {
          isDuplicationOccured = true
          isValid = false
        }

      })
    }
    if (isDuplicationOccured) {
      let decriptionTxt = (
        <>
          <p>To and BCC email address should not have similar mail ids.</p>
        </>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
      });
    }
    if (isValid) {
      dispatch(getSendPoVendorEmail({
        fromEmailAddress: userDetails?.emailId,
        toEmailAddress: poVendorEmailDetails?.toEmailAddress,
        bccEmailAddress: poVendorEmailDetails?.bccEmailAddress,
        emailSubject: poVendorEmailDetails?.emailSubject,
        emailBody: bodyHtmlTemp?.__html,
        emailAttachments: sendEmailAttachmentsList,
        poNumber: poVendorEmailDetails?.poNumber,
        fleetRequestDetailId: itemDetailsTemp?.fleetRequestDetailId
      }))
    } else {
      setSendEmailerror({ ...sendEmailError, bodyEmailError: bodyEmailErrorTemp, toEmailError: toEmailErrorTemp })
    }
  }

  useEffect(() => {
    if (isPoVendorEmailSent?.isValid && isPoVendorEmailSent != null && isPoVendorEmailSent?.fleetRequestDetailId == purchaseOrderStepperData?.fleetRequestDetailId) {
      hidePopup()
      if(fleetPOVendorEmailHistory?.length > 0){
        let tempData = fleetPOVendorEmailHistory?.find(
          (item: any) => item?.id == itemDetails?.fleetRequestDetailId
        );
        if(tempData?.isOpen && itemDetails?.poNumber){
          dispatch(
            getFleetVendorEmailHistory({
              fleetDetailId:  itemDetails?.fleetRequestDetailId,
              poNumber: itemDetails?.poNumber,
              pageNumber: tempData?.pageNumber,
              pageSize: tempData?.pageSize,
            })
          )
        }
      }
      setIsEmailSentAlert({
        type: 'success',
        text: "Mail Sent Successfully",
        showAlert: true,
        fleetRequestDetailId: isPoVendorEmailSent?.fleetRequestDetailId
      })
    } else if (!isPoVendorEmailSent?.isValid && isPoVendorEmailSent != null && isPoVendorEmailSent?.fleetRequestDetailId == purchaseOrderStepperData?.fleetRequestDetailId) {
      setIsEmailSentAlert({
        type: 'warning',
        text: isPoVendorEmailSent?.validationMessage,
        showAlert: true,
        fleetRequestDetailId: isPoVendorEmailSent?.fleetRequestDetailId
      })
    }
  }, [isPoVendorEmailSent])

  const dismissMailAlert = () => {
    setIsEmailSentAlert(null)
    if(isEmailSentAlert?.type == 'success'){
      hidePopup()
    }
  }

  const onClickRefreshPurchaseOrder = () => {
     dispatch(getRefreshPurchaseOrder({
      fleetRequestDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
      poNumber: purchaseOrderStepperData?.poNumber,
      savedBy: userDetails?.emailId
     }))
  }

  const handleLinkClick = (item?: any) => {
    if (item) {
      if(item.props.itemKey != 'vendorEmailHistory-bukorderfleet' && fleetPOVendorEmailHistory?.length > 0){
        let tempData = fleetPOVendorEmailHistory?.find(
          (item: any) => item?.id == itemDetails?.fleetRequestDetailId
        );
       dispatch(setFleetVendorEmailHistory({...tempData, isOpen : false}))
      }
      if(item?.props?.itemKey != 'PurchaseOrderHistory-fleet' && fleetPurchaseOrderHistory?.length > 0){
        let tempData = fleetPurchaseOrderHistory?.find(
          (item: any) => item?.id == itemDetails?.fleetRequestDetailId
        );
       dispatch(setFleetPurchaseOrderHistory({...tempData, isOpen : false}))
      }
  }
}

  useEffect(() => {
    if (poPdfLinkByPONumber != null){
    if (poPdfLinkByPONumber?.response?.isSuccess && poPdfLinkByPONumber?.fleetRequestDetailId == purchaseOrderStepperData?.fleetRequestDetailId) {
      let poDetailsArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr))
      poDetailsArr?.forEach((item: any) => {
        if (item.poNumber == poPdfLinkByPONumber.poNumber) {
          item.poPdfUrl = poPdfLinkByPONumber?.response?.pdfUrl
        }
      })
      dispatchStepperDataArr(poDetailsArr)
      openLinkInNewTab(poPdfLinkByPONumber?.response?.pdfUrl)
    }else if (!poPdfLinkByPONumber?.response?.isSuccess && poPdfLinkByPONumber?.fleetRequestDetailId == purchaseOrderStepperData?.fleetRequestDetailId) {
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: poPdfLinkByPONumber?.response?.errorMessage ?? "Kindly try after few minutes.",
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
      });
    }
    dispatch(setPoPdfLinkByPONumber(null))
  }
  }, [poPdfLinkByPONumber])


  return (
    <VehicleRequestDetail
      itemDetails={itemDetails}
      orderDetails={orderDetails}
      stepperListData={stepperListData}
      handleClickNext={handleClickNext}
      handleClickPrevious={handleClickPrevious}
      StepperRef={StepperRef}
      activeStepper={activeStepper}
      panelList={panelList}
      SelectedVehiclesCount={true}
      assignTo={assignTo}
      accordionIndex={accordionIndex}
      dismissAlert={dismissAlert}
      error={error}
      handleChange={handleChange}
      handleChangeDropDown={handleChangeDropDown}
      purchaseOrderStepperData={purchaseOrderStepperData}
      errors={errors}
      onCloseLinkAttachment={onCloseLinkAttachment}
      onChangeLinkAttachment={onChangeLinkAttachment}
      onClicktLinkAttachment={onClicktLinkAttachment}
      isAttachmentBtnClicked={isAttachmentBtnClicked}
      getLinkedAttachmentsCount={getLinkedAttachmentsCount}
      attachmentsList={attachmentsList}
      linkedAttachment={linkedAttachment}
      assignedToError={assignedToError}
      skipVendorDetail={skipVendorDetail}
      check={check}
      onClickAttachment={onClickAttachment}
      savedStatus={savedStatus}
      yearDropdownList={yearDropdownList}
      usedDropdownList={usedDropdownList}
      enableEditNSE={enableEditNSE}
      handleClickSaveNSE={handleClickSaveNSE}
      handleClickEditNSE={handleClickEditNSE}
      editAssetInfo={editAssetInfo}
      onChangeMake={onChangeMake}
      onChangeModel={onChangeModel}
      onChangeYear={onChangeYear}
      onChangeUsed={onChangeUsed}
      onChangePrice={onChangePrice}
      unitPriceFormat={unitPriceFormat}
      setCancelledItemFleetId = {setCancelledItemFleetId}
      isBulkOrder={isBulkOrder}
      list={list}
      setList={setList}
      uploadedList={uploadedList}
      onUploadClick={onUploadClick}
      attachmentError={attachmentError}
      setAttachmentError={setAttachmentError}
      onRemoveClick={onRemoveClick}
      autoSaveComments={autoSaveComments}
      isnonStandardequipment={isnonStandardequipment}
      ismanagedequipment={ismanagedequipment}
      isvehiclerequestequipment={isvehiclerequestequipment}
      isRequisitionComplete={isRequisitionComplete}
      onClickReturnToHome={onClickReturnToHome} 
      isVendorDetailsSkippedOnSave = {isVendorDetailsSkippedOnSave}
      onChnageQuoteAttached={onChnageQuoteAttached} 
      onDescriptionChange={onDescriptionChange}
      onClickViewPurchaseOrder={onClickViewPurchaseOrder}
      onClickSendPoToVendor = {onClickSendPoToVendor}
      showEmailPopup = {showEmailPopup}
      hidePopup = {hidePopup}
      handleClickTriggerEmail = {handleClickTriggerEmail}
      setSendEmailAttachmentsList = {setSendEmailAttachmentsList}
      sendEmailAttachmentsList = {sendEmailAttachmentsList}
      setSendEmailList = {setSendEmailList}
      sendEmailList = {sendEmailList}
      setEmailAttachmentError = {setEmailAttachmentError}
      emailAttachmentError = {emailAttachmentError}
      sendEmailError = {sendEmailError}
      setSendEmailerror = {setSendEmailerror}
      dismissMailAlert = {dismissMailAlert}
      isEmailSentAlert = {isEmailSentAlert}
      isPoVendorEmailSent = {isPoVendorEmailSent}
      Popupcontent = {Popupcontent}
      hideDialog = {hideDialog}
      popupOutlinebtnOnclick = {popupOutlinebtnOnclick}
      onClickRefreshPurchaseOrder = {onClickRefreshPurchaseOrder}
      isRefreshError = {isRefreshError}
      handleLinkClick = {handleLinkClick}
      handleClickReturnToRequestor = {handleClickReturnToRequestor}
      returnPopupcontent = {returnPopupcontent}
      returnSuccessPopupContent = {returnSuccessPopupContent}
    />
  );
};

export default VehicleRequestDetailContainer;
